// import lottie from './lottie.min';
// import { SVG as MySVG, Point, Matrix } from './svg.js';
// import SVGPoints from './svg-points';
// const {toPath} = require('./svg-points');
// import GifReader from './omggif';
import MySVG from './svg';
import { getArtStyle, artTextInit, artTextPlay } from './artPlay';
import CreateSceneEffect from './sceneEffect';
import Subtitles from './subtitle';
import SoundPlayHandle from './soundPlay';
import {handleAssetsUrl, loadFont} from './comFunc';

const Point = MySVG.Point;
const Matrix = MySVG.Matrix;

const parseAPNG = window['apng-js'].default;

/* 缓动动画函数接收的4个参数：
  * t: currentIteration 当前的迭代计数（可以视为time或frame）
  * b: startValue 初始值
  * c: changeInValue 变化值（最终值与初始值之差）
  * d: totalIteration 总迭代次数（可视为duration）
  */
const EasingAnim = [
  function (t, b, c, d) {
    return c * (t / d) + b;
  },
  function (t, b, c, d) { // easeOutExpo
    return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
  },
  function (t, b, c, d) { // easeOutQuint
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  },
  function (t, b, c, d, s) { // easeOutBack
    if (s == undefined) s = 1.70158;
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  },
  function(t, b, c, d) { // easeInOutElastic
    let s = 1.70158;
    let p = 0;
    let a = c;
    if (t == 0) return b;
    if ((t /= d / 2) == 2) return b + c;
    if (!p) p = d * (.3 * 1.5);
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else s = p / (2 * Math.PI) * Math.asin(c / a);
    if (t < 1) return -1.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 1.5 + c + b;
  },
  function (t, b, c, d, s) { // easeInBack
    if (s == undefined) s = 1.70158;
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  }
];
const PathEasing = [
  function (t, b, c, d) {
    return c * (t / d) + b;
  },
  function (t, b, c, d) { // easeInOutQuad
    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
    return -c / 2 * ((--t) * (t - 2) - 1) + b;
  },
  function (t, b, c, d) { // easeOutQuint
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  }
];

// 首字母大写
const Capitalize = function(string){
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const ConstructAnimPath = function(width, height) {
  // 涂抹手绘路径
  let off = Math.max(5, Math.round(width / 10));
  let x = - off;
  let y = - off;
  let paths = [['M', x, y]];
  let d = '';
  width += off;
  height += off;
  while ((x - width) < height || (y - height) < width) {
    x += off;
    y += off;
    if (x > width) {
      paths.push(['L', width + off / 2, x - width]);
    }else {
      paths.push(['L', x, 0]);
    }
    if (y > height) {
      paths.push(['L', y - height, height + off / 2]);
    }else {
      paths.push(['L', 0, y]);
    }
  }
  paths.forEach(function (path) {
    d += path.join(' ') + ' ';
  });
  return {
    d: d,
    'stroke-width': off,
    'stroke-linejoin': 'round',
    'stroke': 'white',
    'fill': 'none'
  };
};

const formAppJson = function(json) {
  if (json.optimized === "Vertical") {
    let resolution = json.resolution;
    let tarResolution = { width: 1920, height: 1080 }
    let scenes = json.scenes;
    if (scenes && scenes.length > 0) {
        let dx = (tarResolution.width - parseFloat(resolution.width)) / 2;
        scenes.forEach((scene) => {
            if (scene && scene.sprites.length > 0) {
                scene.resolution = tarResolution;
                scene.sprites.forEach((sprite) => {
                    sprite["outward"].x += dx;
                })
            }
        })
    }
    json.resolution = tarResolution;
  }
}

class AnimEditor {
  constructor(id, option = {}) {
    this.id = id;
    this.option = option; // 有接收，但是没有用到
    this.optimized = 'Horizontal'; // 预览适配   0:Horizontal（16:9） 1:Square(1:1) 2:Vertical(9:16)
    this.width = 1920; // 默认宽高1080P
    this.height = 1080;
    this.frameRate = option.frameRate || 30;
    this.title = '';
    this.scenes = []; // 场景页容器
    this.scenesEffect = []; // 动画和场景页脱钩，另外给容器
    this.subtitles = new Subtitles(); // 字幕
    this.soundPlayHandle = new SoundPlayHandle(); // 声音
    this.previewVolume = 100;

    this.checkMaterial = []; // 付费素材（fromJson的时候就开始id和fileType的收集） 放入vue中会不会更好
    this.loadLength = 0; // 需要加载的数量（for loading progress）

    // 关于播放的属性
    this.nowTime = 0;
    this.totalTime = 0;
    this.isPlay = false;
    this.playFrame = null;
    this.scenesPlayData = [];
    this.scenesEffectPlayData = [];
    this.interval = null;
  }
  async fromJson(json) {
    if (json.targetPlatform === 'App') {
      formAppJson(json);
    }
    let scenes = json.scenes;

    // 路径动画的播放（位置计算）
    let svgPathCalc = document.getElementById('svg-path-calc-preview');
    AnimEditor.svgForPath = MySVG().addTo(svgPathCalc);
    // AnimEditor.svgForPath = MySVG('svg-path-calc-preview');
    ({id: this.id, title: this.title, optimized: this.optimized} = json);
    // 下面的代码应该是没有用的， json数据应该都是1080P的。 （如果不是需手动写缩放尺寸方法）
    this.width = json.resolution.width;
    this.height = json.resolution.height;

    console.log(`Turbo ~ AnimEditor ~ fromJson ~ json.subtitle`, json.subtitle)
    if(json.subtitle) {
      this.subtitles.fromJson(json.subtitle);
    }
    if(json.music) {
      this.soundPlayHandle.fromJson(json.music);
    }

    // for vip material check
    if(json.sound && json.sound[0] && json.sound[0].resourceId && json.sound[0].fileType) {
      this.checkMaterial.push({
        id: json.sound[0].resourceId,
        resourceId: json.sound[0].resourceId,
        fileType: json.sound[0].fileType,
        uuid: 'TOOLsound',
        scenesId: 'TOOLsound',
        type: 'TOOLsound'
      });
    }

    let props = this.getPropsData(['frameRate', 'optimized']);
    for (let i=0; i<scenes.length; i++) {
      let scene = new ScenesSprite(props);
      // 防止index有重复的
      scenes[i].index = i;
      await scene.fromJson(scenes[i], this.checkMaterial);

      // 没有写加入场景页方法 直接push
      this.scenes.push(scene);
      if(i < scenes.length - 1) {
        // let effect = CreateSceneEffect(scenes[i].exitEffect.type);
        let effect = CreateSceneEffect('None');
        // 资源在本地加载应该很块
        await effect.initDom(this.optimized);
        this.scenesEffect.push(effect);
      }
      this.loadLength += scene.loadLength;
    }
  }
  getData() {
    let scenes = [];
    let scenesEffect = [];
    for(let i = 0, len = this.scenes.length; i < len; i++) {
      scenes.push(this.scenes[i].getData());
    }
    for(let i = 0, len = this.scenesEffect.length; i < len; i++) {
      scenesEffect.push(this.scenesEffect[i].getData());
    }
    return {
      id: this.id,
      scenes: scenes,
      scenesEffect: scenesEffect,
      loadLength: this.loadLength,
      checkMaterial: this.checkMaterial
    };
  }
  getPropsData(types = []) {
    let obj = {};
    types.forEach(v => {
      obj[v] = this[v];
    })
    return obj;
  }
  updateScenesPlayData() {
    this.scenesPlayData = [];
    this.scenesEffectPlayData = [];
    let totalTime = 0;
    this.totalTime = 0;
    for(let i = 0; i < this.scenes.length; i++) {
      totalTime += this.scenes[i].duration;
      this.scenesPlayData.push(totalTime);
      if(i < this.scenes.length - 1) {
        this.scenesEffect[i].init(this.scenes[i], this.scenes[i+1]);
        this.scenesEffectPlayData.push(
          [totalTime-this.scenesEffect[i].startAt, totalTime-this.scenesEffect[i].startAt + this.scenesEffect[i].duration]
        )
      }
    }
    this.totalTime = totalTime;
  }
  getScenesFrame(time) {
    let obj = {
      index: 0,
      frame: 0
    };
    for(let i = 0; i < this.scenesPlayData.length; i++) {
      if(time <= this.scenesPlayData[i]) {
        obj.index = i;
        break;
      }
    }
    obj.frame = Math.round((time - (this.scenesPlayData[obj.index-1] || 0)) * this.frameRate);
    return obj;
  }
  play(data) {
    // {isplay, time} isplay是否正在播放，time播放开始的时间（单位秒）
    Object.assign({
      isplay: false,
      time: 0
    }, data)
    let obj = this.getScenesFrame(data.time);
    for(let i = 0; i < this.scenes.length; i++) {
      if(i < obj.index) {
        this.scenes[i].show = false;
        this.scenes[i].initReset(0);
      } else if(i === obj.index) {
        this.scenes[i].show = true;
        this.scenes[i].initReset(obj.frame);
      } else {
        this.scenes[i].initReset(0);
        this.scenes[i].play(0);
        this.scenes[i].show = false;
      }
      this.scenesEffect[i] && this.scenesEffect[i].recovery()
    }
    this.subtitles.initPlay();
    this.soundPlayHandle.play(data);
    if(this.isPlay) {
      if(data.isPlay) {
        this.nowTime = data.time;
      } else {
        this.nowTime = data.time;
        this.isPlay = false;
        this.stepPlay();
      }
    } else {
      if(data.isPlay) {
        this.nowTime = data.time;
        this.isPlay = true;
        this.interval = setInterval(() => {
          this.stepPlay();
        }, 1000 / this.frameRate);
      } else {
        this.nowTime = data.time;
        this.isPlay = false;
        this.stepPlay();
      }
    }
  }
  stepPlay() {
    let obj = this.getScenesFrame(this.nowTime);
    this.currentSceneIndex = obj.index;

    if(!this.isPlay) {
      this.soundPlayHandle.play({isPlay: false});
      clearInterval(this.interval);
    } else {
      this.soundPlayHandle.stepPlay(this.nowTime);
    }
    // 转场播放
    let se = this.scenesEffect[obj.index];
    let ts = this.scenesEffectPlayData[obj.index];
    if(!ts) ts = [this.totalTime];
    if(obj.index > 0  && this.nowTime < ts[0]) {
      se = this.scenesEffect[obj.index - 1];
      ts = this.scenesEffectPlayData[obj.index - 1];
    }
    if(this.scenesEffect[obj.index - 1] && this.scenesEffect[obj.index - 1] !== se) {
      this.scenesEffect[obj.index - 1].stop();
    }
    if(se) {
      if(this.nowTime < ts[0]) {
        se.start()
      } else if(this.nowTime > ts[1]) {
        se.stop()
      } else {
        se.play(this.nowTime - ts[0])
      }
    }
    if(this.scenes[obj.index - 1]) {
      this.scenes[obj.index - 1].initReset(0);
    }
    this.scenes[obj.index].play(obj.frame, this.isPlay);
    this.subtitles.play(this.nowTime);

    this.nowTime += 1 / this.frameRate;
    if(this.nowTime > this.totalTime) {
      this.nowTime = this.totalTime;
      this.isPlay = false;
    }
  }

  changePreviewVolume (num) {
    this.previewVolume = num;
    this.soundPlayHandle.changePreviewVolume(num);
    this.scenes.forEach(scene => {
      scene.sprites.forEach(sprite => {
        if (sprite.type === 'Video') {
          sprite.previewVolume = this.previewVolume / 100 * sprite.volume;
          sprite.dom.volume = sprite.previewVolume / 100;
        }
        if (sprite.type === 'Lottie' && sprite.sound && sprite.sound.ele) {
          const sound = sprite.sound;
          sound.previewVolume = this.previewVolume / 100 * sound.volume;
          sound.ele.volume = sound.previewVolume / 100;
        }
      });
    });
  }

  static svgForPath = null // 路径动画的svgdom
}

class ScenesSprite {
  constructor(option) {
    this.id = '';
    this.index = 0;
    this.duration = 10;
    this.sprites = []; // 元素容器
    this.camera = null; // 镜头容器
    this.background = null; // 背景
    this.frameRate = option.frameRate;
    this.optimized = option.optimized;

    this.zIndex = 1; // 用于dom层级
    this.show = true; // 是否显示(加载的时候需要显示)
    this.frame = 0; // 当前场景页的播放位置

    // 以下变量为了播放
    this.transform = '';
    this.transformOrigin = '';
    this.opacity = 1;
    this.clipPath = '';
    this.transformStyle = '';
    this.filter = '';

    this.loadLength = 0; // need load  num = sprite num + background
    this.loaded = false;
    this.resetPlay = false;
  }
  async fromJson(json, cm) {
    let sprites = json.sprites;
    ({id: this.id, index: this.index, duration: this.duration} = json);
    this.zIndex = this.index * 5 + 1;
    let background = json.background;
    // 仅加载数据, background dom init in vue.
    let props = this.getPropsData(['frameRate', 'optimized']);
    if(background.type === 'Color') {
      this.background = new SceneBackground();
    } else if(background.type === 'Image') {
      this.background = new SceneImageBackground(props);
    } else if(background.type === 'Video') {
      this.background = new SceneVideoBackground(props);
    }
    this.background.fromJson(background);

    this.camera = new Camera(props);
    this.camera.fromJson(json.cameras);

    // for vip material check
    if(json.resourceId) {
      cm.push({
        id: json.resourceId,
        fileType: 24
      });
    }
    if(background.resourceId && background.fileType) {
      cm.push({
        id: background.resourceId,
        fileType: background.fileType
      });
    }
    if(json.groupList && json.groupList.length) {
      json.groupList.forEach(g => {
        cm.push({
          id: g.resourceId,
          type: g.type,
          uuid: g.id,
          fileType: g.fileType
        });
      });
    }

    for (let i=0; i< sprites.length; i++) {
      // 无新class来加载对应元素
      // 图表元素暂时没有载入，后期加入todo
      if(sprites[i].type === 'Chart') continue;
      let sprite = this.loadSprite(sprites[i].type, props);
      await sprite.fromJson(sprites[i]);
      // 无加载元素方法，直接push
      this.sprites.push(sprite);
      cm.push(...sprite.forVip);
    }
    this.loadLength = this.sprites.length + 1;
  }
  loadSprite(type, props) {
    let sprite = null;
    switch (type) {
      case 'Text':
        sprite = new TextSprite(props);
        break;
      case 'Image':
        sprite = new ImageSprite(props);
        break;
      case 'Lottie':
        sprite = new LottieSprite(props);
        break;
      case 'Svg':
        sprite = new SvgSprite(props);
        break;
      case 'Gif':
        sprite = new GifSprite(props);
        break;
      case 'ImageFrame':
      case "Frame":
        sprite = new FrameSprite(props);
        break;
      case 'Video':
        sprite = new VideoSprite(props);
        break;
      case 'RichText':
        sprite = new RichTextSprite(props);
        break;
      case 'Chart':
        sprite = new ChartSprite(props);
        break;
      default:
        break;
    }

    return sprite;
  }
  getThumbDom(frame) {
    // 获取frame位置的dom(当作缩略图)
    let dom = document.createElement('div');
    // because default size is 1080P (if not, you need change)
    dom.style.position = 'absolute';
    dom.style.width = '1920px';
    dom.style.height = '1080px';
    for(let i = 0; i < this.sprites.length; i++) {
      let sdom = this.sprites[i].getThumbDom(frame);
      if(sdom) dom.appendChild(sdom);
    }
    // 直接在dom上添加背景（缩略图不会考虑很多）
    this.background.getThumbDom(dom);
    return dom;
  }
  cloneDom(noBg = false){
    // 为了场景页动画
    let dom = document.createElement('div');
    dom.style.position = 'absolute';
    dom.style.top = '0px';
    dom.style.left = '0px';
    dom.style.width = '1920px';
    dom.style.height = '1080px';
    // camera dom
    let cameraDom = this.camera.createDom();
    // 可能不需要复制背景dom
    !noBg && cameraDom.appendChild(this.background.createDom());
    for(let i = 0; i < this.sprites.length; i++) {
      let sdom = this.sprites[i].cloneDom();
      if(sdom) cameraDom.appendChild(sdom);
    }
    dom.appendChild(cameraDom);
    return dom;
  }
  getData(){
    return {
      index: this.index,
      duration: this.duration,
      frame: this.frame,
      loaded: this.loaded,
      play: false
    };
  }
  getImageNum(){
    let nums = 0;
    this.sprites.forEach(s => {
      if(s instanceof ImageSprite || s instanceof GifSprite) {
        nums ++;
      }
    });
    return nums;
  }
  getPropsData(types = []) {
    let obj = {};
    types.forEach(v => {
      obj[v] = this[v];
    })
    return obj;
  }
  play(frame, isPlay){
    this.resetPlay = false;
    this.camera.play(frame)
    this.background.play(frame, isPlay)
    this.frame = frame;
    for(let i = 0; i < this.sprites.length; i++) {
      this.sprites[i].effect.play(frame, isPlay)
    }
  }
  initReset(frame) {
    if(this.resetPlay) return;
    this.resetPlay = true;
    this.background.play(frame, false);
    for(let i = 0; i < this.sprites.length; i++) {
      this.sprites[i].effect.initReset();
      if(this.sprites[i] instanceof VideoSprite) {
        this.sprites[i].initVideo(frame)
      }
      if(this.sprites[i] instanceof LottieSprite) {
        this.sprites[i].playAudio(0, false);
      }
    }
  }
}
class SceneBackground { // 背景基类（也是color class）
  constructor() {
    this.type = 'Color';
    this.blur = 0;
    this.opacity = 1;
    this.color = '#ffffff';
    this.dom = null;

    this.show = true; // 是否显示（播放时）
  }
  fromJson(json){
    ({
      type: this.type,
      blur: this.blur,
      opacity: this.opacity,
      color: this.color
    } = json);
  }
  play(){}
  setFilter(){ // 获取滤镜string方法
    let filterCss = [];
    for (var item in this.filter) {
      switch (item) {
        case 'blur':
          var temp = 1080 / 22 * this.filter.blur * 0.01;
          filterCss.push('blur(' + temp + 'px)');
          break;
        case 'brightness':
          filterCss.push('brightness(' + this.filter.brightness + ')');
          break;
        case 'contrast':
          filterCss.push('contrast(' + this.filter.contrast + ')');
          break;
        case 'saturate':
          filterCss.push('saturate(' + this.filter.saturate + ')');
          break;
        case 'grayscale':
          filterCss.push('grayscale(' + this.filter.grayscale + ')');
          break;
        case 'hueRotate':
          filterCss.push('hue-rotate(' + this.filter.hueRotate + 'deg)');
          break;
        case 'invert':
          filterCss.push('invert(' + this.filter.invert + ')');
          break;
        case 'sepia':
          filterCss.push('sepia(' + this.filter.sepia + ')');
          break;
      }
    }
    return filterCss.join(' ');
  }
  getThumbDom(dom) {
    dom.style.backgroundColor = this.color;
  }
  createDom(){
    let dom = document.createElement('div');
    dom.style.position = 'absolute';
    dom.style.top = '0px';
    dom.style.left = '0px';
    dom.style.width = '1920px';
    dom.style.height = '1080px';
    dom.style.overflow = 'hidden';
    dom.style.background = this.color;
    return dom;
  }
}
class SceneImageBackground extends SceneBackground {
  constructor(option){
    super();
    this.frameRate = option.frameRate;
    this.optimized = option.optimized;
    this.color = 'transparent'; // 图片的话背景色为透明
    this.url = '';
    this.laying = 'fill'; // 铺设状态
    this.filter = { // 元素滤镜
      blur: 0, // 模糊
      brightness: 1, // 亮度
      contrast: 1, // 对比度
      saturate: 1, // 饱和度
      grayscale: 0, // 灰度
      hueRotate: 0, // 色相
      invert: 0, // 反色
      sepia: 0 // 加温
    };
    this.effect = null; // 变焦动画
    this.scale = 1; // 变焦带来的缩放属性
  }
  fromJson(json){
    super.fromJson(json);
    this.url = json.url;
    this.laying = json.laying;
    Object.assign(this.filter, json.filter);
    this.effect = Object.assign({}, json.effect);
    if(this.effect.zoomStartScale === this.effect.zoomEndScale) {
      this.effect.active = false;
    } else {
      this.effect.active = true;
      this.effect.change = this.effect.zoomEndScale - this.effect.zoomStartScale;
      this.effect.duration = Effect.ms2fps((this.effect.zoomEndTime - this.effect.zoomStartTime)*1000, this.frameRate);
      this.zoomTick(0);
    }
  }
  play(frame){
    if(!this.show) return;
    this.zoomTick(frame);
  }
  async initDom(dom){
    let imgPro = new Promise((resolve) => {
      let img = new Image();
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => {
        resolve(false);
      };
      img.src = handleAssetsUrl(this.url);
    });
    let img = await imgPro;
    if(!img) return;
    let layingProps = this.getLaying(img);
    dom.style.backgroundImage = `url(${img.src})`;
    dom.style.backgroundColor = '#fff';
    dom.style.backgroundSize = `${layingProps.w}px ${layingProps.h}px`;
    dom.style.filter = this.setFilter();
    if (layingProps.tile) {
      dom.style.backgroundRepeat = 'repeat';
      dom.style.backgroundPosition = `${30 + layingProps.tileOffsetX}px 30px`;
    }
    this.dom = dom;
  }
  getLaying(img) {
    // 各种铺设位置计算（没有竖版的逻辑）
    let w = 1920,
      h = 1080,
      ratioFlag = 16 / 9,
      naturalWidth = img.naturalWidth,
      naturalHeight = img.naturalHeight,
      ratio = naturalWidth / naturalHeight,
      tile = false,
      tileOffsetX = 0,
      result = {
        w: naturalWidth,
        h: naturalHeight
      };
    if(this.optimized === 'Vertical') {
      w = 9 / 16 * h;
      ratioFlag = 9 / 16;
    }
    switch (this.laying) {
      case 'fill':
        if (ratio >= ratioFlag) {
          w = h * ratio;
        } else {
          h = w / ratio;
        }
        break;
      case 'fit':
        // 为竖版写了 16/9
        if (ratio >= 16 / 9) { // 横向填满
          h = w / ratio;
        } else { // 竖向填满
          w = h * ratio;
        }
        break;
      case 'tile':
        if(naturalWidth >= naturalHeight && naturalWidth >= w / 4) {
          result.w = w / 4;
          result.h = result.w / naturalWidth * naturalHeight;
        }
        if(naturalWidth < naturalHeight && naturalHeight >= h / 4) {
          result.h = h / 4;
          result.w = result.h / naturalHeight *  naturalWidth;
        }
        w = result.w;
        h = result.h;
        tile = true;
        break;
      case 'stretch':
        break;
    }

    return {
      w: w,
      h: h,
      tile: tile,
      tileOffsetX: tileOffsetX
    };
  }
  zoomTick(frame) {
    if(!this.effect.active) return;
    if (frame < this.effect.duration) {
      this.scale = PathEasing[1](frame, this.effect.zoomStartScale, this.effect.change, this.effect.duration);
    } else {
      this.scale = this.effect.zoomEndScale;
    }
  }
  getThumbDom(dom) {
    dom.appendChild(this.dom.cloneNode(true));
  }
  createDom(){
    let dom = super.createDom();
    let scale = document.createElement('div');
    scale.style.position = 'absolute';
    scale.style.top = '0px';
    scale.style.left = '0px';
    scale.style.width = '1920px';
    scale.style.height = '1080px';
    scale.style.margin = '0 auto';
    scale.style.transform = `scale(${this.scale})`;
    scale.appendChild(this.dom.cloneNode(true));
    dom.appendChild(scale);
    return dom;
  }
}
class SceneVideoBackground extends SceneBackground {
  constructor(option){
    super();
    this.frameRate = option.frameRate;
    this.optimized = option.optimized;
    this.color = 'transparent';
    this.url = '';
    this.poster = '';
    this.filter = {                 // 元素滤镜
      blur: 0, // 模糊
      brightness: 1, // 亮度
      contrast: 1, // 对比度
      saturate: 1, // 饱和度
      grayscale: 0, // 灰度
      hueRotate: 0, // 色相
      invert: 0, // 反色
      sepia: 0 // 加温
    };
    this.effect = null;
    this.startTime = 0;
    this.duration = 1;
    this.video = null;
    this.isPlay = false;
    this.nowLoop = 0;
    this.timeout = null;
    this.preFrame = -1;

    this.scale = 1;
  }
  fromJson(json){
    super.fromJson(json);
    ({
      url: this.url,
      laying: this.laying,
      poster: this.poster,
      duration: this.duration,
      startTime: this.startTime
    } = json);
    Object.assign(this.filter, json.filter);
    this.effect = Object.assign({}, json.effect);
    if(this.effect.zoomStartScale === this.effect.zoomEndScale) {
      this.effect.active = false;
    } else {
      this.effect.active = true;
      this.effect.change = this.effect.zoomEndScale - this.effect.zoomStartScale;
      this.effect.duration = Effect.ms2fps((this.effect.zoomEndTime - this.effect.zoomStartTime)*1000, this.frameRate);
      this.zoomTick(0);
    }
  }
  async initDom(dom) {
    let cutStart = this.startTime;
    let cutEnd = this.startTime + this.duration;
    let video = document.createElement('video');
    let url = this.url;
    if(url.indexOf('http')) {
      url = handleAssetsUrl(this.url);
    }
    video.crossOrigin = true;
    video.src = `${url}#t=${cutStart},${cutEnd}`;
    video.volume = 0;
    video.setAttribute('x5-video-player-type', 'h5-page');
    video.setAttribute('x5-video-player-fullscreen', 'false');
    video.setAttribute('webkit-playsinline', 'true');
    video.setAttribute('playsinline', 'true');

    let loadPro = new Promise(resolve => {
      video.addEventListener('loadedmetadata', loadedmetadata);
      video.addEventListener('error', loadError);
      function loadedmetadata(){
        video.removeEventListener('loadedmetadata', loadedmetadata);
        video.removeEventListener('error',loadError);
        resolve(true);
      }
      function loadError() {
        video.removeEventListener('loadedmetadata', loadedmetadata);
        video.removeEventListener('error',loadError);
        resolve(false);
      }
      setTimeout(() => {
        resolve(true);
      }, 800)
    });
    let ok = await loadPro;
    if(!ok) return;
    this.video = video;
    // dom.style.backgroundImage = `url(${handleAssetsUrl(this.poster)})`;
    dom.style.filter = this.setFilter();
    dom.appendChild(video);
    this.dom = dom;
  }
  play(frame, isPlay) {
    if(!this.show) return;
    this.zoomTick(frame);
    let time = this.frameToTime(frame);
    if(isPlay) {
      if(this.isPlay) {
        if(this.video.currentTime > time+0.5) {
          this.video.currentTime = time;
        }
      } else {
        this.video.currentTime = time;
        this.isPlay = true;
        this.video.play();
      }
    } else {
      if(this.isPlay) {
        this.video.pause();
        this.video.currentTime = time;
        this.isPlay = false;
      } else {
        this.video.currentTime = time;
      }
    }
  }
  frameToTime(frame) {
    let time = frame / this.frameRate;
    time = time % this.duration;
    return time + this.startTime;
  }
  zoomTick(frame) {
    if(!this.effect.active) return;
    if (frame < this.effect.duration) {
      this.scale = PathEasing[1](frame, this.effect.zoomStartScale, this.effect.change, this.effect.duration);
    } else {
      this.scale = this.effect.zoomEndScale;
    }
  }
  getThumbDom(dom) {
    dom.appendChild(this.dom.cloneNode(true));
  }
  createDom(){
    let dom = super.createDom();
    let scale = document.createElement('div');
    scale.style.position = 'absolute';
    scale.style.width = '1920px';
    scale.style.height = '1080px';
    scale.style.margin = '0 auto';
    scale.style.transform = `scale(${this.scale})`;
    scale.appendChild(this.dom.cloneNode(true));
    let video = scale.getElementsByTagName('video')[0];
    video.currentTime = this.video.currentTime;
    dom.appendChild(scale);
    return dom;
  }
}

class SpriteEle {
  constructor(option) {
    this.id = '';
    this.frameRate = option.frameRate;
    this.optimized = option.optimized;
    this.index = 0;
    this.type = '';
    this.width = 0;
    this.height = 0;
    this.top = 0;
    this.left = 0;
    this.rotate = 0;
    this.opacity = 1;
    this.flip = false;
    this.scale = 1;
    this.filter = {                 // 元素滤镜
      blur: 0, // 模糊
      brightness: 1, // 亮度
      contrast: 1, // 对比度
      saturate: 1, // 饱和度
      grayscale: 0, // 灰度
      hueRotate: 0, // 色相
      invert: 0, // 反色
      sepia: 0 // 加温
    };
    this.boxShadow = 'unset';                // 边框阴影
    this.dropShadow = 'unset';               // 元素阴影
    this.border = null;                   // 元素边框
    this.bgColor = '';                    // 背景填充色
    this.dom = null;
    this.effect = null;
    this.loaded = false;

    this.show = false;

    this.forVip = [];
  }
  async fromJson(json) {
    ({id: this.id, zIndex: this.index, type: this.type, cropType: this.cropType, bgColor: this.bgColor} = json);
    ({
      width: this.width,
      height: this.height,
      x: this.left,
      y: this.top,
      rotation: this.rotate,
      opacity: this.opacity,
      isFlipped: this.flip
    } = json.outward);
    Object.assign(this.filter, json.filter);
    json.dropShadow && (this.dropShadow = this.getShadowCss(json.dropShadow, true));
    json.boxShadow && (this.boxShadow = this.getShadowCss(json.boxShadow));
    json.border && (this.border = Object.assign({}, json.border));
    this.effect = new Effect(this);
    if(json.resourceId && json.fileType) {
      this.forVip.push({
        id: json.resourceId,
        fileType: json.fileType
      });
    }
  }
  getShadowCss(shadow, spread = false){
    let str = '';
    for (let i in shadow) {
      if(i !== 'color') {
        if(spread && i === 'spread') continue;
        str += (shadow[i] + 'px ');
      } else {
        str += shadow[i];
      }
    }
    return str;
  }
  initDom(dom) {
    this.dom = dom;
    this.setBorder();
  }
  getInitData() {
    return {
      width: this.width,
      height: this.height,
      top: this.top,
      left: this.left,
      rotate: this.rotate,
      opacity: this.opacity
    };
  }
  setBorder(){
    if(!this.border) return;
    let span = document.createElement('span');
    span.setAttribute('class', 'sprite-border');
    span.style.borderWidth = `${this.border.width * 2}px`;
    span.style.borderStyle = this.border.style;
    span.style.borderColor = this.border.color;
    let str = '',
      radius = [],
      ratio = this.width > this.height ? this.width : this.height;
    for (let i in this.border.radius) {
      radius.push(this.border.radius[i] * ratio / 100);
    }
    str = radius.join('px ') + 'px';
    this.dom.style.borderRadius = str;
    this.dom.style.overflow = 'hidden';
    span.style.borderRadius = str;
    this.dom.appendChild(span);
  }
  setFilter(dom){
    let filterCss = [];
    let noFilter = 9;
    for (var item in this.filter) {
      switch (item) {
        case 'blur':
          var temp = this.height / 22 * this.filter.blur * 0.01;
          temp === 0 && noFilter--;
          filterCss.push('blur(' + temp + 'px)');
          break;
        case 'brightness':
          this.filter.brightness === 1 && noFilter--;
          filterCss.push('brightness(' + this.filter.brightness + ')');
          break;
        case 'contrast':
          this.filter.contrast === 1 && noFilter--;
          filterCss.push('contrast(' + this.filter.contrast + ')');
          break;
        case 'saturate':
          this.filter.saturate === 1 && noFilter--;
          filterCss.push('saturate(' + this.filter.saturate + ')');
          break;
        case 'grayscale':
          this.filter.grayscale === 0 && noFilter--;
          filterCss.push('grayscale(' + this.filter.grayscale + ')');
          break;
        case 'hueRotate':
          this.filter.hueRotate === 0 && noFilter--;
          filterCss.push('hue-rotate(' + this.filter.hueRotate + 'deg)');
          break;
        case 'invert':
          this.filter.invert === 0 && noFilter--;
          filterCss.push('invert(' + this.filter.invert + ')');
          break;
        case 'sepia':
          this.filter.sepia === 0 && noFilter--;
          filterCss.push('sepia(' + this.filter.sepia + ')');
          break;
      }
    }
    // 滤镜
    if (this.dropShadow && this.dropShadow !== 'unset') {
      filterCss.push('drop-shadow(' + this.dropShadow + ')');
    } else {
      noFilter--;
    }
    dom.style.filter = noFilter ? filterCss.join(' ') : '';
  }
  play(){}
  getThumbDom(frame){
    let effect = this.effect,
      enEnd = effect.enterAnim.endF,
      exStart = effect.exitAnim.startF;
    if(frame >= enEnd && frame <=exStart ) {
      let dom = this.dom.cloneNode(true);
      dom.style.display = '';
      dom.style.zIndex = this.index * 5 + 1;
      return dom;
    }else {
      return null;
    }
  }
  cloneDom(){
    if(!this.show) return null;
    let dom = document.createElement('div');
    dom.style.position = 'absolute';
    dom.style.zIndex = this.index * 5 + 1;
    let enterHand = this.effect.enterHand;
    let exitHand = this.effect.exitHand;
    if(enterHand && enterHand.show) {
      let enter = document.createElement('div');
      enter.appendChild(enterHand.img.cloneNode());
      enter.style.position = 'absolute';
      enter.style.top = `${enterHand.top}px`;
      enter.style.left = `${enterHand.left}px`;
      enter.style.zIndex = 20;
      dom.appendChild(enter);
    }
    if(exitHand && exitHand.show) {
      let exit = document.createElement('div');
      exit.appendChild(exitHand.img.cloneNode());
      exit.style.position = 'absolute';
      exit.style.top = `${exitHand.top}px`;
      exit.style.left = `${exitHand.left}px`;
      exit.style.zIndex = 20;
      dom.appendChild(exit);
    }
    return dom;
  }
  dealCloneDom(clone) {
    clone.style.top = `${this.top}px`;
    clone.style.left = `${this.left}px`;
    clone.style.width = `${this.width}px`;
    clone.style.height = `${this.height}px`;
    clone.style.opacity = `${this.opacity}`;
    clone.style.backgroundColor = this.bgColor;
    clone.style.transform = `rotate(${this.rotate}deg) scaleX(${this.flip ? -1: 1}) scale(${this.scale})`;
    clone.style.boxShadow = this.boxShadow;
    clone.style.display = '';
  }
  static makeid() {
    let text = '';
    let possible = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

    for (let i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text + '-o';
  }
  static gifBuffer = []
}
class ImageSprite extends SpriteEle {
  constructor(option) {
    super(option);
    this.url = '';
    this.cropType = '';
    this.cropData = null;
    this.draw = null;
    this.bbox = null;

    this.svg = null;
    this.drawPath = null;

    this.img = null;
  }
  async fromJson(json) {
    await super.fromJson(json);
    ({
      url: this.url,
      cropType: this.cropType
    } = json);
    if(json.cropData) {
      let rx = this.width / json.cropData.width,
        ry = this.height / json.cropData.height,
        originWidth = rx * json.cropData.originWidth,
        originHeight = ry * json.cropData.originHeight,
        deltaX = rx * json.cropData.deltaX,
        deltaY = ry * json.cropData.deltaY;
      this.cropData = Object.assign({}, json.cropData, {
        width: this.width,
        height: this.height,
        originWidth: originWidth,
        originHeight: originHeight,
        deltaX: deltaX,
        deltaY: deltaY
      });
    }
    let enter = json.enterEffect;
    let type = Capitalize(enter.type)
    if (type === 'Write') {
      enter.type = 'FadeIn'
    }
    if (type === 'Hand') {
      enter.type = 'LeftIn'
    }
    await this.effect.fromJson(json);
  }
  async initDom(dom) {
    super.initDom(dom);
    let imgPro = new Promise((resolve) => {
      let img = new Image();
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => {
        resolve(false);
      };

      img.src = handleAssetsUrl(this.url);
    });
    let img = await imgPro;

    if(!img) return;

    img.style.width = '100%';
    img.style.height = '100%';
    this.setFilter(img);
    dom.appendChild(img);
    this.img = img;
    if(this.cropType === 'free'){
      this.freeCrop(img);
    } else if(this.cropType === 'svg') {
      img.style.display = 'none';
      let svg = await this.svgCrop();
      svg && this.setFilter(svg.node);
    }

    await this.effect.initDom();
    this.loaded = true;
  }
  async drawInitDom() {
    let width = this.width,
      height = this.height;
    if(this.cropType === 'free') {
      width = this.cropData.originWidth;
      height = this.cropData.originHeight;
    }
    let svg = null;
    let maskId = SpriteEle.makeid();
    if(this.cropType === 'svg') {
      svg = this.svg;
      svg.findOne('g').css({
        mask: `url(#${maskId}-mask)`
      });
    } else {
      svg = MySVG().addTo(this.dom).attr({
        viewBox: `0 0 ${width} ${height}`,
        preserveAspectRatio: 'none'
      }).css({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 5
      });
      if(this.cropType === 'free') {
        let data = this.cropData;
        let dRo = data.innerRotation - this.rotate;
        dRo %= 360;
        if (dRo > 180) {
          dRo -= 360;
        } else if (dRo <= -180) {
          dRo += 360;
        }
        svg.css({
          width: data.originWidth,
          height: data.originHeight,
          top: data.height / 2 + data.deltaY - data.originHeight / 2,
          left: data.width / 2 + data.deltaX - data.originWidth / 2,
          transform: `rotate(${dRo}deg)`
        });
      }
      this.dom.querySelector('img').style.display = 'none';
      let svgg = svg.group().css({
        mask: `url(#${maskId}-mask)`
      });
      let loadImgPro = new Promise((resolve) => {
        let imgDom = svgg.image(handleAssetsUrl(this.url), () => {
          imgDom.attr({
            preserveAspectRatio: 'none meet',
            width: width,
            height: height
          });
          resolve();
        });
      });
      await loadImgPro;
    }
    this.drawPath = svg.mask().attr({
      id: maskId + '-mask'
    }).path().attr(ConstructAnimPath(width, height));

    let length = this.drawPath.length();
    this.drawPath.attr({
      opacity: 1,
      'stroke-dasharray': length + ' ' + length,
      'stroke-dashoffset': -length
    }).css({stroke: 'white', fill: 'none'});
    this.setFilter(svg.node);
    return length;
  }
  freeCrop(img){
    let data = this.cropData;
    let dRo = data.innerRotation - this.rotate;
    dRo %= 360;
    if (dRo > 180) {
      dRo -= 360;
    } else if (dRo <= -180) {
      dRo += 360;
    }
    this.dom.style.overflow = 'hidden';
    img.style.position = 'absolute';
    img.style.left = `${data.width / 2 + data.deltaX - data.originWidth / 2}px`;
    img.style.top = `${data.height / 2 + data.deltaY - data.originHeight / 2}px`;
    img.style.width = `${data.originWidth}px`;
    img.style.maxWidth = `${data.originWidth}px`;
    img.style.height = `${data.originHeight}px`;
    img.style.transform = `rotate(${dRo}deg)`;
  }
  freeCropPath() {
    if (this.img) {
      let rx = this.width / this.cropData.width,
        ry = this.height / this.cropData.height,
        originWidth = rx * this.cropData.originWidth,
        originHeight = ry * this.cropData.originHeight,
        deltaX = rx * this.cropData.deltaX,
        deltaY = ry * this.cropData.deltaY;
      this.img.style.left = `${this.width / 2 + deltaX - originWidth / 2}px`;
      this.img.style.top = `${this.height / 2 + deltaY - originHeight / 2}px`;
      this.img.style.width = `${originWidth}px`;
      this.img.style.maxWidth = `${originWidth}px`;
      this.img.style.height = `${originHeight}px`;
    }
  }
  async svgCrop(){
    let result = await fetch(handleAssetsUrl(this.cropData.url), {
      method: 'get',
      responseType: 'text'
    });
    if(!result.ok) return;
    let data = this.cropData;
    let maskId = `${SpriteEle.makeid()}-crop-svg`;
    let svgStr = await result.text();
    let reg = /<path(.)*?id="lhImageFrame"(.)*?class="(.)*?"/;
    svgStr = svgStr.replace(reg, '<path class="imageHolderMaskPath" fill="none" ');
    let svg = MySVG(this.dom).svg(svgStr).findOne('svg');
    let maskPathDom = svg.findOne('.imageHolderMaskPath');
    let bbox = svg.attr('viewBox').split(' ');
    svg.clear().attr({
      viewBox: `0 0 ${data.width} ${data.height}`,
      preserveAspectRatio: 'none',
      overflow: 'hidden'
    });
    svg.defs().clip().attr({
      id: maskId,
      transform: `scale(${data.width / bbox[2]}, ${data.height / bbox[3]})`
    }).add(maskPathDom);
    let loadImgPro = new Promise((resolve) => {
      let img = svg.group().attr('clip-path', `url(#${maskId})`).image(handleAssetsUrl(this.url), () => {
        img.attr('preserveAspectRatio', 'none')
          .size(data.originWidth, data.originHeight)
          .move(data.deltaX, data.deltaY);
        resolve(true);
      });
    });
    await loadImgPro;
    this.svg = svg;
    return svg;
  }
  getThumbDom(frame) {
    let dom = super.getThumbDom(frame);
    if(dom) {
      if(this.cropType === 'svg') {
        let id = `${SpriteEle.makeid()}-crop-svg-thumb`;
        dom.getElementsByTagName('clipPath')[0].setAttribute('id', id);
        dom.getElementsByTagName('g')[0].setAttribute('clip-path', `url(#${id})`);
      }
      if(this.effect.enterAnim.type === 'Draw') {
        dom.getElementsByTagName('g')[0].setAttribute('style', '');
        dom.getElementsByTagName('mask')[0].setAttribute('id', '');
      }
      return dom;
    } else {
      return null;
    }
  }
  cloneDom(){
    let dom = super.cloneDom();
    if(dom) {
      let clone = this.dom.cloneNode(true);
      this.dealCloneDom(clone);
      if(this.cropType === 'svg') {
        let id = `${SpriteEle.makeid()}-crop-svg-thumb`;
        clone.getElementsByTagName('clipPath')[0].setAttribute('id', id);
        clone.getElementsByTagName('g')[0].setAttribute('clip-path', `url(#${id})`);
      }
      if(this.effect.enterAnim.type === 'Draw') {
        if (dom.getElementsByTagName('mask')[0]) {
          dom.getElementsByTagName('mask')[0].setAttribute('id', '');
        }
      }
      dom.appendChild(clone);
    }
    return dom;
  }
}
class TextSprite extends SpriteEle{
  constructor(option) {
    super(option);
    this.text = '';
    this.artType = '';
    this.versionAnyway = 'Horizontal';
    this.lineHeight = 1;
    this.letterSpacing = 0;
    this.font = {
      color: '#5779fa',
      fontSize: 24,
      fontFamilyUrl: '2018-5-16/1526467728442.TTF',
      fontStretch: 'normal',
      fontWeight: 'normal',
      fontStyle: 'normal',
      textDecoration: 'none',
      textAlign: 'left',
      wordBreak: 'break-word'
    };
    this.artStyle = null;
    this.artControl = [];

    this.items = [];
    this.writehand = null;
  }
  async fromJson(json) {
    await super.fromJson(json);
    ({
      text: this.text,
      artType: this.artType,
      versionAnyway: this.versionAnyway,
      lineSpacing: this.lineHeight,
      characterSpacing: this.letterSpacing
    } = json);
    Object.assign(this.font, json.font);
    if(this.artType) {
      this.artStyle = getArtStyle(this.artType, this.font.color, this.font.fontSize);
    }
    await this.effect.fromJson(json);
  }
  play(frameOff) {
    if (!this.artType) return;
    let data = {
      size: this.font.fontSize,
      color: this.font.color
    };
    artTextPlay(this.artType, data, this.artControl, frameOff, this.frameRate);
  }
  async initDom(dom) {
    super.initDom(dom);
    let font = this.font;
    let art = this.artStyle;
    let textDom = document.createElement('div');
    await loadFont(font.fontFamilyUrl);
    textDom.innerHTML = this.text;
    textDom.style.font = `${font.fontStyle} ${font.fontWeight} ${font.fontSize}px / ${this.lineHeight} "${font.fontFamilyUrl.split('/').pop()}"`;
    textDom.style.color = font.color;
    textDom.style.textDecoration = font.textDecoration;
    textDom.style.textAlign = font.textAlign;
    textDom.style.wordBreak = font.wordBreak;
    textDom.style.letterSpacing = `${this.letterSpacing * (~~(parseInt(font.fontSize) / 10)) || 0}px`;
    textDom.style.width = `${this.width}px`;
    textDom.style.writingMode = 'inherit';
    textDom.style.webkitBackgroundClip = 'text';
    textDom.style.whiteSpace = 'pre-wrap'; // 不然换行不会生效
    textDom.style.height = 'auto';
    if(art && art.color) {
      if(this.artType === 'Inset') {
        textDom.style.color = art.color;
        textDom.style.backgroundColor = art.backgroundColor;
      }
      textDom.style.textShadow = art.textShadow || '';
    }
    if(this.versionAnyway === 'Vertical') {
      textDom.style.width = 'auto';
      textDom.style.height = `${this.height}px`;
      textDom.style.writingMode = 'vertical-rl';
    }
    dom.appendChild(textDom);
    this.setFilter(textDom);
    await this.effect.initDom();
    this.artType && artTextInit(this.artType, dom, this.artControl);
    this.loaded = true;
  }
  initSingeDom(handTime, times, singleTime) {
    this._splitText();
    let textDiv = this.dom.firstElementChild,
      singles = textDiv.children,
      textNum = singles.length,
      msPerString = this._getTextAnimTime(textDiv, handTime, times, singleTime),
      framePerString = msPerString / 1000 * this.frameRate,
      durFrame = 0;
    textDiv.style.letterSpacing = '';
    if(times) {
      durFrame = framePerString * (times - 1);
    }

    // 为每个字符分配起始和结束帧
    // 默认每字字符在100ms内显示完成，若超过动画入场退场的总时间，则再加快
    // 规则：第一个字符入场前留500ms给手势入场，最后一个字符结束后留500ms给手势退场
    // 中间遇到换行，下一行起始时间往后顺延两个字符时间单位
    this.item = [];
    for(let i = 0; i < textNum; i++) {
      let currentEle = singles[i],
        isEndOfLine = currentEle.getAttribute('is-end-of-line') !== 'null' ? true : null,
        _start = handTime === 1000 ? 0.5 * this.frameRate : 0,
        _end = 0;

      if(this.item[i -1]) {
        _start = this.item[i-1].start + framePerString;
      }
      // 若上一行是行末，则本行的起始时间和结束时间往右延两个单位
      if (this.item[i - 1] && this.item[i - 1].isEndOfLine) {
        _start = this.item[i - 1].start + framePerString * 3;
      }
      _end = _start + framePerString + durFrame;

      this.item.push({
        ele: currentEle,
        isEndOfLine: isEndOfLine,
        start: _start,
        end: _end,
        x: parseFloat(currentEle.style.left),
        y: parseFloat(currentEle.style.top)
      });
    }
    // 画布下方位置、第一个字符位置、最后一个字符位置
  }
  initLineDom() {
    this._splitText(true);
    let textDiv = this.dom.firstElementChild,
      lines = textDiv.children,
      lineNum = lines.length;
    let time = 300;
    let total = this.effect.exitAnim.start -  this.effect.enterAnim.start;
    if(time * lineNum > total) {
      time = total / lineNum;
    }
    let framePerString = (time / 1000) * this.frameRate;
    this.item = [];
    for(let i = 0; i < lineNum; i++) {
      let currentEle = lines[i],
        _start = 0,
        _end = _start + framePerString;
      if(this.item[i - 1]) {
        _start = this.item[i - 1].end;
        _end = _start + framePerString;
      }
      this.item.push({
        ele: currentEle,
        start: _start,
        end: _end
      });
    }
  }
  _splitText(line) {
    // 分割文字
    let st = TextSprite.escape2Html(this.text.replace(/<div.*?>|<br.*?>/g, '').replace(/\r/g, '\n'));
    let dom = this.dom.firstElementChild;
    let font = dom.style.font;
    let letterSpacing = this.letterSpacing;
    let fontSize = this.font.fontSize;
    dom.innerHTML = '';
    // 创建文字对象
    // 该对象是一个三维数组，第一维是以\n为分隔的行，
    // 第二维是以自然超出边界而分的行，
    // 第三维是每个自然行的字符信息，包括content, index和行号
    let textObj = [], AllLine;
    let emptyLine = 0; // 记录空行
    st.split('\n').forEach((part, i) => {
      if(part === '') emptyLine++;
      textObj[i] = [];
      let prev = textObj[i - 1];
      // 计算在遇到空行之前有多少个非空行
      let noEmptyLine = 0; // 记录非空行
      for(let j = 0; j < i; j++) {
        if (part !== '') {
          noEmptyLine += textObj[j].length || 0;
        }
      }
      // 计算前一个段落的总行数
      let prev_lines = prev ? prev[0]
        ? prev[prev.length - 1][prev[prev.length -1].length - 1].line
        : emptyLine + noEmptyLine : 0;
      //遍历每个段落，完成textObj的数据结构
      let sub = 0, line = 0;
      part.split('').reduce((l, t, index, arr) => {
        let text = part[index];
        if (this.versionAnyway !== 'Vertical') {
          let width = TextSprite.getStringInfo(text, font, this.letterSpacing, this.font.fontSize).width;
          sub += width
          if (Math.ceil(sub / this.width) > 1) {
            sub = width;
            line = l + 1;
          } else {
            line = l;
          }
        } else { // 竖版
          let height = TextSprite.getStringInfo(text, font, this.letterSpacing, this.font.fontSize, 'Vertical').height;
          sub += height;
          if (Math.ceil(sub / this.height) > 1) {
            sub = height;
            line = l + 1;
          } else {
            line = l;
          }
        }
        if(index === 0 && line > 1) {
          line = 1;
        }
        //分段的行末
        let isEndOfLine = false;
        if (index === arr.length - 1) {
          isEndOfLine = true;
        }
        // 非分段行（自然换行） l < line 则上一个元素为行末
        if (l < line) {
          let tmp = textObj[i][line - 2];
          if (!tmp) return;
          tmp[tmp.length - 1].isEndOfLine = true;
          l++;
        }
        if (!textObj[i][line - 1]) {
          textObj[i][line - 1] = [{
            content: t,
            index: index,
            line: line + prev_lines /*+ (emptyLine ? emptyLine + 1 : 0)*/,
            isEndOfLine: isEndOfLine
          }];
        } else {
          textObj[i][line - 1].push({
            content: t,
            index: index,
            line: line + prev_lines /*+ (emptyLine ? emptyLine + 1 : 0)*/,
            isEndOfLine: isEndOfLine
          });
        }
        // if (_flag && index === arr.length - 1) emptyLine = 0;
        AllLine = line + prev_lines;
        return l;
      }, 1);
    });
    // 处理每行文字
    if (line) {
      textObj.forEach( o => {
        o.forEach(text=> {
          let yos = 0;
          let sInfo = TextSprite.getStringInfo(text[0].content, font, letterSpacing, fontSize, this.versionAnyway);
          let lineText = document.createElement('div');
          lineText.style.opacity = 0;
          lineText.style.position = 'absolute';
          lineText.setAttribute('is-end-of-line', 'true');
          if (this.versionAnyway !== 'Vertical') {
            yos = (text[0].line - 1) * sInfo.height;
            lineText.style.top = `${yos}px`;
            lineText.style.left = '0px';
            lineText.style.width = '100%';
            // lineText.style.height = `${sInfo.height}px`;
          } else {
            yos = (AllLine - text[0].line) * sInfo.width;
            lineText.style.top = '0px';
            lineText.style.left = `${yos}px`;
            // lineText.style.width = `${sInfo.height}px`;
            lineText.style.height = '100%';
            lineText.style.writingMode = 'vertical-rl';
          }
          let str = '';
          text.forEach(val => {
            str+=val.content;
          });
          lineText.innerText = str;
          lineText.style.textAlign = this.font.textAlign;
          dom.appendChild(lineText);
        });
      });
      return textObj;
    }
    textObj.forEach(o => {
      o.forEach( text => {
        // 当前行的长度
        let yos = 0;
        let sInfo = TextSprite.getStringInfo(text[0].content, font, letterSpacing, fontSize, this.versionAnyway);
        if (this.versionAnyway !== 'Vertical') {
          yos = (text[0].line - 1) * sInfo.height;
        } else {
          yos = (AllLine - text[0].line) * sInfo.width;
        }
        let sub=[], size;
        text.forEach( te => {
          sub.push(te.content);
        });
        sub = sub.join('');
        size = TextSprite.getStringInfo(sub, font, letterSpacing, fontSize, this.versionAnyway);
        text.reduce((po, t) => {
          let sInfo = TextSprite.getStringInfo(t.content, font, letterSpacing, fontSize, this.versionAnyway);
          let single = document.createElement('div');
          single.innerText = t.content;
          single.style.opacity = 0;
          if(this.artType === 'Inset') {
            single.style.backgroundColor = this.font.color;
            single.style.color = 'transparent';
            single.style.backgroundClip = 'inherit';
          }
          single.style.position = 'absolute';
          single.style.textDecoration = this.font.textDecoration || 'none';
          single.setAttribute('is-end-of-line', t.isEndOfLine ? 'true': 'null');
          dom.appendChild(single);
          if (this.versionAnyway !== 'Vertical') {
            single.style.left = po.x + 'px';
            single.style.top = po.y + (t.line - 1) * sInfo.height + 'px';
            return {
              x: po.x + sInfo.width,
              y: 0
            };
          } else {
            single.style.left = yos + 'px';
            single.style.top = po.y + 'px';
            single.style.writingMode = 'vertical-lr';
            return {
              x: 0,
              y: po.y + sInfo.height
            };
          }
        }, {
          x: TextSprite.textMakeup(this.font.textAlign, {box: this.width, line: size.width}),
          y: this.versionAnyway === 'Vertical' ? TextSprite.textMakeup(this.font.textAlign, {box: this.height, line: size.height}) : 0
        });
      });
    });
    return textObj;
  }
  _getTextAnimTime(textDiv, handTime = 0, times = 0, single = 100){
    let total = this.effect.exitAnim.start -  this.effect.enterAnim.start;
    let singles = textDiv.children,
      textNum = singles.length,
      newLine = 0;
    for(let i = 0; i< textNum; i++) {
      let currentELe = singles[i];
      if (currentELe.getAttribute('is-end-of-line') !== 'null' && i !== textNum - 1) {
        newLine++;
      }
    }
    let t = single * (textNum + newLine * 2 + times) + handTime;
    if (t > total) {
      return (total - handTime) / (textNum + newLine * 2 + times);
    } else {
      return single;
    }
  }
  _initWriteHand(hand) {
    let handDom = document.createElement('div');
    handDom.setAttribute('class', 'write-hand-content');
    handDom.style.position = 'absolute';
    handDom.style.left = '0px';
    handDom.style.top = '0px';
    handDom.style.width = '1024px';
    handDom.style.height = '576px';
    handDom.style.transform = `matrix(${Effect.WRITE_HAND_SCALE}, 0, 0, ${Effect.WRITE_HAND_SCALE}, 0, 0)`;
    handDom.style.transformOrigin = '0px 0px 0px';
    handDom.style.pointerEvents = 'none';
    handDom.style.display = 'none';
    let armDom = document.createElement('div');
    armDom.style.position = 'absolute';
    armDom.style.left = `${hand.armLeft}px`;
    armDom.style.top = `${hand.armTop}px`;
    armDom.style.width = '254.4px';
    armDom.style.height = '355.7px';
    armDom.style.transformOrigin = '50% 0px 0px';
    armDom.style.background = `url(${hand.url}) -408.5px 0px no-repeat`;
    handDom.appendChild(armDom);
    let palmDom = document.createElement('div');
    palmDom.style.position = 'absolute';
    palmDom.style.left = '0px';
    palmDom.style.top = '0px';
    palmDom.style.width = '266.7px';
    palmDom.style.height = '385.1px';
    palmDom.style.transformOrigin = '75% 90% 0px';
    palmDom.style.background = `url(${hand.url}) 0px 0px no-repeat`;
    handDom.appendChild(palmDom);
    let penDom = document.createElement('div');
    penDom.style.position = 'absolute';
    penDom.style.left = '32px';
    penDom.style.top = '84.3px';
    penDom.style.width = '140.8px';
    penDom.style.height = '149.8px';
    penDom.style.transformOrigin = '15% 15% 0px';
    penDom.style.background = `url(${hand.url}) -267.2px 0px no-repeat`;
    palmDom.appendChild(penDom);

    this.dom.appendChild(handDom);

    this.writehand = {
      ele: handDom,
      arm: armDom,
      palm: palmDom,
      pen: penDom
    };
  }
  getThumbDom(frame) {
    let dom = super.getThumbDom(frame);
    if(dom) {
      if(this.writehand) {
        let handDom = dom.getElementsByClassName('write-hand-content')[0];
        dom.removeChild(handDom);
      }
      dom.firstElementChild.innerText = this.text;
      return dom;
    } else {
      return null;
    }
  }
  cloneDom(){
    let dom = super.cloneDom();
    if(dom) {
      let clone = this.dom.cloneNode(true);
      this.dealCloneDom(clone);
      dom.appendChild(clone);
    }
    return dom;
  }
  static escape2Html(str) {
    let arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' };
    return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, (all, t) => { return arrEntities[t]; });
  }
  static getStringInfo(s, font, letterSpacing, fontSize, type) {
    let f = font || '12px arial',
      o = document.createElement('div'),
      ls = parseFloat(letterSpacing * (~~(parseInt(fontSize) / 10)) || 0);
    const measureCtx = new OffscreenCanvas(500, 500).getContext('2d');
    measureCtx.font = f;
    const measure = measureCtx.measureText(s);
    let width = measure.width + ls * s.length;
    o.innerText = s;
    o.style.position = 'absolute';
    o.style.float = 'left';
    o.style.visibility = 'hidden';
    o.style.whiteSpace = 'pre';
    o.style.font = f;
    o.style.letterSpacing = ls + 'px';
    if(type === 'Vertical') {
      o.style.writingMode = 'vertical-rl';
    }
    document.body.appendChild(o);
    type === 'Vertical' && (width = o.clientWidth);
    let result = {
      width: width,
      height: o.clientHeight
    };
    document.body.removeChild(o);
    return result;
  }
  /**
   * 排版算法（居中，居左，居右）
   * @param {String} type 类型，有'center', 'left', 'right'
   * @param {Object} w 对象，包含文本框宽度及当前行文字宽度
   * @return {number} 返回第一个字符的left值
   */
  static textMakeup(type, w) {
    let result = 0;
    switch (type) {
      case 'left':
        result = 0;
        break;
      case 'right':
        result = w.box - w.line;
        break;
      case 'center':
      default:
        result = (w.box - w.line) / 2;
        break;
    }
    return result;
  }
}
class LottieSprite extends SpriteEle{
  constructor(option) {
    super(option);
    this.url = '';
    this.numberOfLoops = 5;
    this.isLoop = true;

    this.sFrameRate = 0;
    this.totalFrames = 0;
    this.lottie = null;
    this.frame = 0;
    this.sound = null;
  }
  async fromJson(json) {
    await super.fromJson(json);
    ({
      url: this.url,
      numberOfLoops: this.numberOfLoops,
      isLoop: this.isLoop
    } = json);
    if(json.sound) {
      let audio = document.createElement('audio');
      this.sound = {
        load: true,
        volume: typeof json.sound.volume === 'number' ? json.sound.volume : 50,
        ele: audio,
        play: false,
        duration: json.sound.duration
      }
      audio.onerror = () => {
        this.sound.load = false;
        this.sound.ele = null;
        audio.onerror = null;
      }
      audio.onloadedmetadata = () => {
        this.sound.duration = audio.duration;
        audio.onloadedmetadatao = null;
      }
      audio.volume = this.sound.volume / 100;
      audio.loop = true;
      audio.autoplay = false;
      audio.src = handleAssetsUrl(json.sound.url);
      audio.load();
    }
    await this.effect.fromJson(json);
  }
  async initDom(dom) {
    super.initDom(dom);
    dom.setAttribute('data-animation-path', handleAssetsUrl(this.url));
    dom.setAttribute('data-anim-type', 'svg');
    // dom.setAttribute('data-anim-autoplay', true);
    dom.setAttribute('data-anim-autoplay', false);
    dom.setAttribute('data-anim-loop', this.isLoop);
    dom.setAttribute('data-anim-prerender', true);

    let lottiePro = new Promise((resolve) => {
      let instance = lottie.registerAnimation(dom);

      instance.addEventListener('DOMLoaded', () => {
        instance.isDOMLoaded = true;
        this.sFrameRate = instance.frameRate;
        this.totalFrames = instance.totalFrames;

        instance.renderer.svgElement.setAttribute('preserveAspectRatio', 'none');
        resolve(instance);
      });

      instance.addEventListener('complete', () => {
        instance.setCurrentRawFrameValue(0);
        resolve(instance);
      });
    });

    this.lottie = await lottiePro;
    this.setFilter(this.dom.querySelector('svg'));
    await this.effect.initDom();
    // setTimeout(() => {
    //   this.lottie.stop();
    // }, 500)
    this.loaded = true;
  }
  play(frame, isPlay) {
    frame < 0 ? 0 : frame;
    let rate = this.frameRate / this.sFrameRate,
      frameCalc = frame / rate % this.totalFrames;

    if (this.numberOfLoops === 0 && !this.isLoop) {
      this.lottie.setCurrentRawFrameValue(0)
      return;
    }

    if(!this.isLoop && frame / rate >= this.numberOfLoops * this.totalFrames) {
      frameCalc = this.totalFrames-1;
      this.playAudio(frameCalc, false)
    } else {
      this.playAudio(frameCalc, isPlay)
    }
    if(frameCalc === this.frame) return;
    this.frame = frameCalc;
    this.lottie.setCurrentRawFrameValue(frameCalc);
  }
  playAudio(frame, isPlay) {
    if(!this.sound || !this.sound.load) return;
    let ele = this.sound.ele;
    if(isPlay) {
      let time = this.frameToTime(frame);
      if(time < 0) {
        if(this.sound.play) {
          ele.pause();
          this.sound.play = false;
        }
      }
      if(this.sound.play) {
        // 循环播放，（音乐应该不会短于0.7s吧, 是的话直接循环播放吧）
        if(ele.currentTime > time + 0.7) {
          ele.currentTime = time;
        }
      } else {
        ele.currentTime = time;
        this.sound.play = true;
        ele.play();
      }
    } else {
      if(this.sound.play) {
        this.sound.play = false;
        ele.pause();
      }
    }
  }
  frameToTime(frame) {
    let time = frame / this.frameRate;
    if(time > this.duration) {
      return -1;
    }
    return time;
  }
  getThumbDom(frame) {
    let dom = super.getThumbDom(frame);
    if(dom) {
      let masks = dom.getElementsByTagName('mask');
      for(let i = 0; i < masks.length; i++) {
        masks[i].setAttribute('id', null);
      }
      return dom;
    } else {
      return null;
    }
  }
  cloneDom(){
    let dom = super.cloneDom();
    if(dom) {
      let clone = this.dom.cloneNode(true);
      this.dealCloneDom(clone);
      let masks = clone.getElementsByTagName('mask');
      let clipPath = clone.getElementsByTagName('clipPath');
      for(let i = 0; i < masks.length; i++) {
        masks[i].setAttribute('id', '');
      }
      for(let i = 0; i < clipPath.length; i++) {
        clipPath[i].setAttribute('id', '');
      }
      dom.appendChild(clone);
    }
    return dom;
  }
}
class SvgSprite extends SpriteEle{
  constructor(option) {
    super(option);
    this.url = '';
    this.fill = '';
    this.stroke = '';
    this.strokeWidth = 4;
    this.fileType = 0;

    this.svg = null;
    this.items = null;
    this.START_MS = 500;
    this.playerSvg = null;

    this.drawPath = null;
  }
  async fromJson(json) {
    await super.fromJson(json);
    ({
      url: this.url,
      color: this.fill,
      stroke: this.stroke,
      fileType: this.fileType,
      strokeWidth: this.strokeWidth
    } = json);
    await this.effect.fromJson(json);
  }
  async initDom(dom) {
    super.initDom(dom);
    let result = await fetch(handleAssetsUrl(this.url), {
      method: 'get',
      responseType: 'text'
    });

    if(!result.ok) return;

    let svgStr = await result.text();
    let draw = MySVG(dom);
    draw.svg(svgStr);
    let svg = draw.find('svg')[0];
    svg.css({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      'z-index': 20
    }).attr('preserveAspectRatio', 'none');
    draw = null;

    this._id2unique(svg);
    this._style2cssinline(svg);
    this._parseToPath(svg);
    this.svg = svg;
    this.setFilter(svg.node);
    await this.effect.initDom();
    this.loaded = true;
  }
  async drawInitDom() {
    let s = new XMLSerializer().serializeToString(this.svg.node);
    let src = 'data: image/svg+xml;base64, ' + window.btoa(unescape(encodeURIComponent(s)));
    let svg = MySVG().addTo(this.dom).attr({
      viewBox: `0 0 ${this.width} ${this.height}`,
      preserveAspectRatio: 'none'
    }).css({
      position: 'abolute',
      top: 0,
      left: 0,
      zIndex: 5
    });
    let maskId = SpriteEle.makeid();
    let svgg = svg.group().css({
      mask: `url(#${maskId}-mask)`
    });
    let loadImgPro = new Promise((resolve) => {
      let imgDom = svgg.image(src, () => {
        imgDom.attr({
          width: this.width,
          height: this.height
        });
        resolve();
      });
    });
    await loadImgPro;
    this.drawPath = svg.mask().attr({
      id: maskId + '-mask'
    }).path().attr(ConstructAnimPath(this.width, this.height));

    let length = this.drawPath.length();
    this.drawPath.attr({
      opacity: 1,
      'stroke-dasharray': length + ' ' + length,
      'stroke-dashoffset': -length
    }).css({stroke: 'white', fill: 'none'});
    this.svg.hide();
    this.setFilter(svg.node);
    return length;
  }
  _id2unique(svg) {
    svg.find('[id]').each((value) => {
      let new_id = SpriteEle.makeid();
      let old_id = value.attr('id');
      let reg = new RegExp(old_id, "g");
      svg.node.innerHTML = svg.node.innerHTML.replace(
        reg,
        new_id
      );
      // svg.select("style,defs,symbol,pattern,use,g,mask,path").forEach(function () {
      //   let reg = new RegExp(old_id, "g");
      //   this.node.innerHTML = this.node.innerHTML.replace(
      //       reg,
      //       new_id
      //   );
      // });
      //value.attr('id', new_id);
    });
  }
  _style2cssinline(svg) {
    let styletag = svg.find('style')[0];
    if (!styletag) return;

    // 兼容firefox和chrome
    let _html = styletag.node.innerHTML || styletag.node.textContent;
    let styleObj = this._getStyleObj(_html);

    svg.find('*').each((value) => {
      let classname = value.attr('class');
      if (!classname) return;
      let cls = classname.split(' ');
      cls.forEach((c) => {
        let cobj = styleObj[c.trim()],
          style = value.style() || '';
        if (cobj) {
          value.attr('style', style ? style + ';' + cobj : cobj);
        }
      });
      value.attr('class', null);
    });
  }
  _basicAttr(e) {// 获取和SVG绘制相关的属性
    let node = e.node;
    let result = {
      stroke: node.getAttribute('stroke'),
      'stroke-width': node.getAttribute('stroke-width'),
      'stroke-miterlimit': node.getAttribute('stroke-miterlimit'),
      'stroke-linecap': node.getAttribute('stroke-linecap'),
      'stroke-linejoin': node.getAttribute('stroke-linejoin'),
      fill: node.getAttribute('fill') || this._getStyle(e.node, 'fill'),
      transform: node.getAttribute('transform')
    };

    if (result.stroke === 'none' || !result.stroke) result.stroke = this._getStyle(e.node, 'stroke');
    let attrFill = this._getStyle(e.node, 'fill');
    if (attrFill === 'none') {
      result.fill = attrFill;
    } else if (this.fill && this.isEditable) {
      result.fill = this.fill;
    }
    if (!result['stroke-width']) result['stroke-width'] = this._getStyle(e.node, 'stroke-width');

    return result;
  }
  _getStyle(el, styleProp) {// 获取属性值，包括css和inline。
    let defaultView = (el.ownerDocument || document).defaultView;
    styleProp = styleProp.replace(/([A-Z])/g, '-$1').toLowerCase();
    return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
  }
  _parseToPath(svg) {
    // 将特殊形状的元素转为path形式
    // 圆形
    svg.find('circle').each((e) => {
      let r = e.attr('r'),
        cx = e.attr('cx'),
        cy = e.attr('cy'),
        s = `M${cx} ${cy}m-${r},0a${r},${r} 0 1,0 ${r*2},0a${r},${r} 0 1,0 -${r*2},0`;
      let o = this._basicAttr(e);
      if (e.node.style.fill.indexOf('url(') > -1) {
        o.fill = e.node.style.fill;
      }
      let el = svg.path(s).attr(o);
      e.after(el).remove();
    });
    // 椭圆
    svg.find('ellipse').each((e) => {
      let cx = e.attr('cx'), rx = e.attr('rx'),
        cy = e.attr('cy'), ry = e.attr('ry'),
        cxrx = cx - rx,
        s = `M${cxrx},${cy}a${rx},${ry} 0 1,0 ${rx*2},0a${rx},${ry} 0 1,0 -${rx*2},0`,
        el = e.parent().path(s).attr(this._basicAttr(e));
      e.after(el).remove();
    });
    // 折线/多边形
    svg.find('polyline, polygon').each((e) => {
      let tagName = e.node.tagName.toLowerCase();
      let points = e.attr('points').trim().split(/\s+/);

      points = {
        type: tagName,
        points: e.attr('points').trim()
      };

      let s = SVGPoints.toPath(points);
      let o = this._basicAttr(e);
      let el = svg.path(s).attr(o);

      e.after(el).remove();
    });

    svg.find('rect').each((e) => {
      let shape = {
        type: 'rect',
        height: 20,
        width: 50,
        x: 10,
        y: 10,
        rx: 2,
        ry: 2
      };
      for(let k in shape) {
        if (k === 'type') continue;
        shape[k] = e.attr(k);
      }
      let s = SVGPoints.toPath(shape);
      let o = this._basicAttr(e);
      if (e.node.style.fill.indexOf('url(') > -1) {
        o.fill = e.node.style.fill;
      }
      let el = svg.path(s).attr(o);
      e.after(el).remove();
    });

    // 直线
    svg.find('line').each((e) => {
      let s = `M${e.attr('x1') || 0},${e.attr('y1') || 0}L${e.attr('x2') || 0},${e.attr('y2') || 0}`,
        el = e.parent().path(s).attr(this._basicAttr(e));

      e.after(el).remove();
    });

    let isEditable = /^(28|29)$/.test(this.fileType);
    let strokeWidth = 0;
    if(isEditable) {
      strokeWidth = this.strokeWidth * Math.min(svg.node.viewBox.animVal.width / this.width, svg.node.viewBox.animVal.height / this.height) * 1.626;
    }
    // 将所有path上通过class设置的样式转为inline样式
    svg.find('path').each((e) => {
      let cls = [], attr = this._basicAttr(e);
      for (let i = 0, len = e.node.classList.length; i < len; i++) {
        cls.push(e.node.classList[i]);
      }

      for (let j = 0, leng = cls.length; j < leng; j++) {
        e.node.classList.remove(cls[j]);
      }

      if (
        SvgSprite.urlFillRE.test(e.node.style.fill)
        || SvgSprite.urlFillRE.test(e.node.getAttribute('fill'))
      ) {
        attr.fill = e.node.getAttribute('fill') || e.node.style.fill;
      }
      if(isEditable) {
        if (this.fill && attr.fill && attr.fill !== 'none' && attr.fill !== 'transparent') {
          attr.fill = this.fill;
          e.css('fill', this.fill);
        }

        if(attr.stroke !== 'none' && attr.stroke !== 'transparent') {
          this.stroke && e.css('stroke', this.stroke);
          e.css('stroke-width', `${strokeWidth}px`);
        }

      }
      e.attr(attr);
    });
  }
  _getStyleObj(str) {
    let arr = str ? str.match(/[\S\s]+?\}/g) : [],
      classobj = {};
    arr.forEach((a) => {
      let split = a.split('{');
      let sname = split[0].trim(),
        content = split[1].split('}')[0].replace(/\n/g, '').trim();
        // 有逗号分隔的情况
      if (sname.indexOf(',') !== -1) {
        let c = sname.split(',');
        c.forEach((i) => {
          i = i.trim();
          let attr = i.substr(1);
          if (i[0] === '.') {
            classobj[attr] = classobj[attr] ? classobj[attr] += ';' + content : content;
          }
        });
      } else {
        // class obj
        let attr = sname.substr(1);
        if (sname[0] === '.') {
          classobj[attr] = classobj[attr] ? classobj[attr] += ';' + content : content;
        }
      }
    });
    return classobj;
  }
  setHandDom(){
    let svg = this.svg;
    let pssvg = MySVG().addTo(this.dom);
    pssvg.attr({
      'viewBox': svg.attr('viewBox'),
      'preserveAspectRatio': 'none',
      'style': 'position:absolute;top:0;left:0;width:100%;height:100%'
    });
    let maskId = SpriteEle.makeid() + '-mask';
    let pssvgg = pssvg.group();
    let mask = pssvg.mask().attr('id', maskId);
    let drawDuration = this.effect.enterAnim.drawDuration - 500;
    if(drawDuration < 500) drawDuration = 500;
    this.items = [];
    pssvgg.css({
      'mask': 'url(#' + maskId + ')',
      'display': 'block'
    });

    let paths = svg.find('path');
    let hasStroke = paths.some(p => {
      let css = p.css('stroke') || 'none';
      let attr = p.attr('stroke') || 'none';
      return css !== 'none' || attr !== 'none';
    });

    paths.forEach(p => {
      let gParent = p.parent(SVG.G);
      let bbox = null;
      if(gParent && gParent.attr('transform')) {
        bbox = gParent.attr('transform');
      }

      const cp = p.clone();

      let stroke = cp.attr('stroke');
      if((!stroke || stroke === 'none') && !hasStroke) {
        if(p.parents('mask')[0].type === 'mask') {
          stroke = '#fff';
        } else {
          stroke = '#999';
        }
        cp.attr('stroke', stroke);
        cp.attr('stroke-width', '1px');
      } else if(stroke && (this.fileType === 28 || this.fileType === 29)) {
        cp.css('stoke', this.stroke);
        cp.attr('stroke', this.stroke);
      }
      // 获取每条path的长度
      if (!stroke || stroke !== 'none') {
        this.items.push({
          el: cp,
          length: cp.length(),
          matrix: cp.attr('transform') ? cp.node.transform.baseVal.consolidate().matrix : null,
          transform: bbox || null
        });
      }
      pssvgg.add(cp);
    });

    let groups = svg.find('g').filter((el) => {
      let hasTransform = el.attr('transform');
      let chs = el.children();
      let hasPath = false;
      chs.forEach((ch) => {
        return ch.tagName === 'path' && (hasPath = true);
      });
      return hasPath && hasTransform;
    });
    let _count = 0;
    groups.length && pssvgg.clear();
    groups.forEach((el) => {
      let g = pssvg.group().clear();
      let len = el.find('path').length;
      let part = this.items.slice(_count, len);
      _count = len;
      part.map((v) => {
        g.add(v.el);
      });

      g.attr('transform', el.attr('transform'));
      pssvgg.add(g);
    });

    let totalLength = 0;
    // 获取总长度
    for (var i = 0, len = this.items.length; i < len; i++) {
      totalLength += this.items[i].length;
    }
    for (let i = 0, len = this.items.length, ms = this.START_MS; i < len; i++) {
      let item = this.items[i];
      item.el = item.el.clone();
      item.start = ms;
      item.startF = Effect.ms2fps(ms, this.frameRate);
      item.end = item.length > 0 ? ms + item.length / totalLength * drawDuration : ms;
      item.endF = Effect.ms2fps(item.end, this.frameRate);
      ms = item.end;
      mask.add(item.el);
      if (item.length > 0) {
        item.fill = item.el.attr('fill');
        item.el.attr({
          opacity: 1,
          'stroke-width': Math.max(parseFloat(item.el.attr('stroke-width')), 1),
          'stroke-dasharray': item.length + ' ' + item.length,
          'stroke-dashoffset': -item.length
        }).css({ stroke: '#fff', fill: 'none' });
      } else {
        item.el.attr('opacity', 0);
      }
    }
    _count = 0;
    groups.length && mask.clear();
    groups.forEach((el) => {
      let g = pssvg.group().clear();
      let len = el.find('path').length;
      let part = this.items.slice(_count, len);
      _count = len;
      part.map((v) => {
        g.add(v.el);
      });
      g.attr('transform', el.attr('transform'));
      mask.add(g);
    });

    svg.hide();
    this.setFilter(pssvg.node);
    this.playerSvg = pssvg;
    if (pssvgg.find('path').length === 1 && this.items.length === 1) {
      mask.hide();
      this.items[0].el = pssvgg.find('path')[0];
      this.items[0].el.attr({
        'stroke-dasharray': this.items[0].length + ' ' + this.items[0].length,
        'stroke-dashoffset': -this.items[0].length
      })
    }
  }
  getThumbDom(frame) {
    let dom = super.getThumbDom(frame);
    if(dom) {
      let child = dom.lastElementChild;
      while(child) {
        dom.removeChild(child);
        child = dom.lastElementChild;
      }
      let svg = this.svg.clone();
      svg.show();
      this._id2unique(svg);
      svg.addTo(dom);
      return dom;
    } else {
      return null;
    }
  }
  cloneDom(){
    let dom = super.cloneDom();
    if(dom) {
      let clone = this.dom.cloneNode(true);
      this.dealCloneDom(clone);
      let child = clone.lastElementChild;
      while(child) {
        clone.removeChild(child);
        child = clone.lastElementChild;
      }
      if(this.playerSvg) {
        let playSvg = this.playerSvg.clone();
        this._id2unique(playSvg);
        playSvg.show();
        playSvg.addTo(clone);
      } else {
        let svg = this.svg.clone();
        this._id2unique(svg);
        svg.show();
        svg.addTo(clone);
      }
      dom.appendChild(clone);
    }
    return dom;
  }
  static urlFillRE = /url\(.*#.*\)/
}
class GifSprite extends SpriteEle{
  constructor(option) {
    super(option);
    this.url = '';
    this.isLoop = true;
    this.numberOfLoops = 5;

    this.pixelBuffer = null;
    this.frames = [];
    this.totalFrames = 0;
    this.sFrameRate = 0;
    this.cWidth = 0;
    this.cHeight = 0;
    this.imageData = null;
    this.canvas = document.createElement('canvas');
    this.frame = 0;
  }
  async fromJson(json) {
    await super.fromJson(json);
    ({
      url: this.url,
      isLoop: this.isLoop,
      numberOfLoops: this.numberOfLoops
    } = json);
    await this.effect.fromJson(json);
  }
  async initDom(dom) {
    if (this.isApng()) {
      return this.initDomApng(dom);
    }
    super.initDom(dom);
    let width = 0,
      height = 0;
    let hasParse = false;
    for (let i = 0; i < SpriteEle.gifBuffer.length; i++) {
      let v = SpriteEle.gifBuffer[i];
      if (v.url === this.url) {
        v.index++;
        if(!v.pixelBuffer) {
          let ok = await new Promise(resolve => {
            let time = 0;
            let inter = setInterval(function(){
              if(v.pixelBuffer) {
                clearInterval(inter);
                resolve(true);
              }
              time += 200;
              if(time >= 20000) {
                clearInterval(inter);
                resolve(false);
              }
            }, 200);
          });
          if(!ok) return;
        }
        this.pixelBuffer = v.pixelBuffer;
        this.frames = v.frames;
        this.totalFrames = v.frames.length;
        this.sFrameRate = v.frames[this.totalFrames - 1] / this.totalFrames;
        [width, height] = [v.width, v.height];
        hasParse = true;
        break;
      }
    }
    if(!hasParse) {
      let data = {
        url: this.url,
        index: 0,
        pixelBuffer: null,
        frames: 0,
        width: 0,
        height: 0
      };
      SpriteEle.gifBuffer.push(data);
      let result = await fetch(handleAssetsUrl(this.url), {
        method: 'get',
        responseType: 'arraybuffer'
      });
      if(!result.ok) return;
      let gifBuffer = await result.arrayBuffer();

      let reader = new GifReader(new Uint8Array(gifBuffer));
      let frames = reader.frames;
      [width, height] = [reader.width, reader.height];
      let pixelBuffer = new Uint8ClampedArray(frames.length * width * height * 4);
      let frameArr = new Uint8ClampedArray(width * height * 4);
      let last = { disposal: 0 };
      let rate = this.frameRate;

      //  ignores delays below 0.06 seconds per frame
      this.frames[0] = (frames[0].delay || 6) / 100 * rate;
      for (let i = 0; i < frames.length; i++) {
        if (i !== 0) {
          this.frames[i] = (frames[i].delay || 6) / 100 * rate + this.frames[i - 1];
          last = frames[i - 1];
        }
        if (last.disposal === 2) {
          if (!last.x && !last.y && last.width === width && last.height === height) {
            frameArr = new Uint8ClampedArray(width * height * 4);
          } else {
            let arrB = new Uint8ClampedArray(last.width * 4);
            for (let j = 0; j < last.height; j++) {
              frameArr.set(arrB, ((last.y + j) * width + last.x) * 4);
            }
          }
        } else if (last.disposal === 3) {
          frameArr = new Uint8ClampedArray(width * height * 4);
        }
        reader.decodeAndBlitFrameRGBA(i, frameArr);
        pixelBuffer.set(frameArr, i * width * height * 4);
      }
      frameArr = null;
      this.pixelBuffer = pixelBuffer;
      data.pixelBuffer = pixelBuffer,
      data.frames = this.frames,
      data.width = width,
      data.height = height;
      this.totalFrames = this.frames.length;
      this.sFrameRate = this.frames[this.totalFrames - 1] / this.totalFrames;
      reader = null;
    }

    [this.cWidth, this.cHeight] = [width, height];
    this.canvas.width = width;
    this.canvas.height = height;
    this.canvas.style.transformOrigin = '0 0';
    this.canvas.style.float = 'left';
    this.canvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
    this.imageData = this.canvas.getContext('2d').createImageData(width, height);
    this.canvas.style.transform = `scale(${this.width / width}, ${this.height / height})`;
    this.canvas.style.willChange = 'transform';

    this.imageData.data.set(this.pixelBuffer.subarray(0, width * height * 4));
    this.canvas.getContext('2d').putImageData(this.imageData, 0, 0);
    this.setFilter(this.canvas);
    dom.appendChild(this.canvas);
    await this.effect.initDom();
    this.loaded = true;
  }
  async initDomApng (dom) {
    super.initDom(dom);
    let width = 0,
      height = 0;


    let data = {
      url: this.url,
      index: 0,
      pixelBuffer: null,
      frames: 0,
      width: 0,
      height: 0
    };
    // SpriteEle.gifBuffer.push(data);
    let result = await fetch(handleAssetsUrl(this.url), {
      method: 'get',
      responseType: 'arraybuffer'
    });
    if(!result.ok) return;
    let gifBuffer = await result.arrayBuffer();

    let reader = parseAPNG(gifBuffer);
    let frames = reader.frames;
    [width, height] = [reader.width, reader.height];
    // let pixelBuffer = new Uint8ClampedArray(frames.length * width * height * 4);
    // let frameArr = new Uint8ClampedArray(width * height * 4);
    // let last = { disposal: 0 };
    let rate = this.frameRate;

    const apng = reader;
    this.apng = apng;
    for (let i = 0; i < frames.length; i++) {
      if (i !== 0) {
          this.frames[i] =
              ((frames[i].delay || 100) / 1000) * rate +
              this.frames[i - 1];

      } else {
          this.frames[0] = ((frames[0].delay || 100) / 1000) * rate;
      }
    }

    await apng.createImages();
    const canvas = this.canvas;
    canvas.width = apng.width;
    canvas.height = apng.height;

    const p = await apng.getPlayer(canvas.getContext('2d'));
    this.apngPlayer = p;
    this.play(15);

    // frameArr = null;
    // this.pixelBuffer = pixelBuffer;
    // data.pixelBuffer = pixelBuffer;
    data.frames = this.frames;
    data.width = width;
    data.height = height;
    this.totalFrames = this.frames.length;
    this.sFrameRate = this.frames[this.totalFrames - 1] / this.totalFrames;
    reader = null;


    [this.cWidth, this.cHeight] = [width, height];
    this.canvas.width = width;
    this.canvas.height = height;
    this.canvas.style.transformOrigin = '0 0';
    this.canvas.style.float = 'left';
    this.canvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
    // this.imageData = this.canvas.getContext('2d').createImageData(width, height);
    this.canvas.style.transform = `scale(${this.width / width}, ${this.height / height})`;
    this.canvas.style.willChange = 'transform';

    // this.imageData.data.set(this.pixelBuffer.subarray(0, width * height * 4));
    // this.canvas.getContext('2d').putImageData(this.imageData, 0, 0);
    this.setFilter(this.canvas);
    dom.appendChild(this.canvas);
    await this.effect.initDom();
    this.loaded = true;
  }
  isApng () {
    return /\.apng$/i.test(this.url);
  }
  play(frame) {
    if (this.isApng()) {
      return this.playAPNG(frame);
    }
    let total = this.frames.length - 1,
      n = frame / this.frames[total],
      i = 0;
    frame = frame % this.frames[total];
    if (this.numberOfLoops === 0) {
      this.imageData.data.set(this.pixelBuffer.subarray(0, this.cWidth *  this.cHeight * 4));
      this.canvas.getContext('2d').putImageData(this.imageData, 0, 0);
      return;
    }
    for (i in this.frames) {
      if (frame < this.frames[i]) break;
    }
    if (!this.isLoop && this.numberOfLoops < n) {
      i = total;
    }
    if(i === this.frame) return;
    this.frame = i;
    this.imageData.data.set(this.pixelBuffer.subarray(i * this.cWidth *  this.cHeight * 4, (+i + 1) *  this.cWidth *  this.cHeight * 4));
    this.canvas.getContext('2d').putImageData(this.imageData, 0, 0);
  }
  playAPNG (frame) {
    var total = this.frames.length - 1;
    var n = frame / this.frames[total];
    frame = frame % this.frames[total];
    for (var i in this.frames) {
        if (frame < this.frames[i]) break;
    }
    if (!this.isLoop && this.numberOfLoops < n) {
        i = total;
    }
    this.apngPlayer.jumpFrame(i);
  }
  getThumbDom(frame) {
    if (this.isApng()) {
      return;
    }
    let dom = super.getThumbDom(frame);
    if(dom) {
      let canvas = dom.getElementsByTagName('canvas')[0];
      canvas.getContext('2d').putImageData(this.imageData, 0, 0);
      return dom;
    } else {
      return null;
    }
  }
  cloneDom(){
    let dom = super.cloneDom();
    if(dom) {
      let clone = this.dom.cloneNode(true);
      this.dealCloneDom(clone);
      let canvas = clone.getElementsByTagName('canvas')[0];
      canvas.getContext('2d').putImageData(this.imageData, 0, 0);
      dom.appendChild(clone);
    }
    return dom;
  }
}
class FrameSprite extends SpriteEle{
  constructor(option) {
    super(option);
    this.url = '';
    this.picUrl = '';
    this.fileType = '';
    this.frameData = {};
    this.matrix = {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      rotate: 0
    };

    this.isGif = false;
    this.pixelBuffer = null;
    this.frames = [];
    this.totalFrames = 0;
    this.sFrameRate = 0;
    this.cWidth = 0;
    this.cHeight = 0;
    this.imageData = null;
    this.canvas = null;
    this.frame = 0;
  }
  async fromJson(json) {
    await super.fromJson(json);
    ({
      url: this.url
    } = json);
    let fill = json.fillContent;
    if(fill) {
      this.picUrl = fill.url;
      this.fileType = fill.fileType;
      this.isGif = fill.fileType === 34;
      this.matrix = {
        x: fill.offsetX,
        y: fill.offsetY,
        width: fill.width,
        height: fill.height,
        rotate: fill.rotation
      };
    }
    await this.effect.fromJson(json);
  }
  matrixTran(m, bbox) {
    let newM = Object.assign({}, m);
    newM.x = m.x + bbox.width / 2 + bbox.x - m.width / 2;
    newM.y = m.y + bbox.height / 2 + bbox.y - m.height / 2;
    return newM;
  }
  async initDom(dom) {
    super.initDom(dom);
    // 不显示就不会有bbox数据
    this.show = true;
    let result = await fetch(handleAssetsUrl(this.url), {
      method: 'get',
      responseType: 'text'
    });
    if(!result.ok) return;

    let svgStr = await result.text();
    let picContent = this.initFrameDom(svgStr, dom);
    this.show = false;
    if(!picContent || !this.picUrl) {
      await this.effect.initDom();
      this.loaded = true;
      return;
    }

    let mx = this._calcMatrix(this.matrixTran(this.matrix, this.frameData.bbox));

    if(this.isGif) {
      await this.parseGif();
      picContent.node.innerHTML = '<foreignObject><canvas></canvas></foreignObject>';
      let fo = picContent.node.getElementsByTagName('foreignObject')[0];
      for(let k in mx) {
        fo.setAttribute(k, mx[k]);
      }
      this.canvas = picContent.node.getElementsByTagName('canvas')[0];
      this.canvas.width = this.cWidth;
      this.canvas.height = this.cHeight;
      this.canvas.style.transformOrigin = '0 0';
      this.canvas.style.float = 'left';
      this.canvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
      this.imageData = this.canvas.getContext('2d').createImageData(this.cWidth, this.cHeight);
      this.canvas.style.transform = `scale(${mx.width / this.cWidth}, ${mx.height / this.cHeight})`;
      this.canvas.style.willChange = 'transform';

      this.imageData.data.set(this.pixelBuffer.subarray(0, this.cWidth * this.cHeight * 4));
      this.canvas.getContext('2d').putImageData(this.imageData, 0, 0);
    }else {
      let loadImgPro = new Promise((resolve) => {
        let picDom = picContent.image(handleAssetsUrl(this.picUrl), () => {
          picDom.attr(mx);
          resolve();
        });
        setTimeout(() => {
          resolve();
        }, 10000);
      });
      await loadImgPro;
    }
    await this.effect.initDom();
    this.loaded = true;
  }
  initFrameDom(svg, dom) {
    let reg = /<path(.)*?id="lhImageFrame"(.)*?class="(.)*?"/;
    svg = svg.replace(reg, '<path class="imageHolderMaskPath" fill="none" ');
    // 初始化content层的DOM结构
    let frameData = this.frameData;
    let svgMask = document.createElement('div');
    let imgContent = document.createElement('div');
    let frameContent = document.createElement('div');
    svgMask.setAttribute('class', 'frame-mask');
    imgContent.setAttribute('class', 'frame-image');
    frameContent.setAttribute('class', 'frame-content');

    this.setFilter(frameContent);
    this.setFilter(imgContent);

    dom.appendChild(svgMask);
    dom.appendChild(imgContent);
    dom.appendChild(frameContent);

    let draw = MySVG(frameContent);
    draw.svg(svg);
    // 相框svg元素
    let uuid = SpriteEle.makeid();
    let frameSvg = draw.find('svg')[0];
    let maskId = 'frame-' + uuid + '-clip-path';
    frameContent.appendChild(frameSvg.node);
    draw = null;

    this._id2unique(frameSvg);

    // 相框的各种属性赋值
    let viewBox = frameSvg.attr('viewBox');
    let maskPathDom = frameSvg.find('.imageHolderMaskPath')[0];
    frameData.viewBox = viewBox.split(' ');
    if (!maskPathDom) {
      return false;
    }

    this._style2cssinline(frameSvg);
    frameData.bbox = maskPathDom.bbox();
    if (maskPathDom.attr('transform')) {
      let matrix = maskPathDom.node.transform.animVal[0].matrix;
      frameData.bbox.x = matrix.e;
      frameData.bbox.y = matrix.f;
    }
    frameData.bbox.ratio = frameData.bbox.width / frameData.bbox.height;
    // clip-path的SVG
    let maskDom = MySVG().addTo(svgMask).attr({
      viewBox: viewBox,
      x: 0,
      y: 0,
      width: '100%',
      height: '100%'
    });
    // 在maskDom 中生成clipPath元素
    let clipPath = maskDom.defs().clip().attr({
      id: maskId
    });
    clipPath.add(maskPathDom.clone());
    // 图片的SVG
    let imgContentDom = MySVG().addTo(imgContent).attr({
      viewBox: viewBox,
      x: 0,
      y: 0
    }).css('overflow', 'hidden');
    let picContent = imgContentDom.group().attr('clip-path', 'url(#' + maskId + ')');
    return picContent;
  }
  async parseGif(){
    let width = 0,
      height = 0;
    let hasParse = false;
    for (let i = 0; i < SpriteEle.gifBuffer.length; i++) {
      let v = SpriteEle.gifBuffer[i];
      if (v.url === this.url) {
        v.index++;
        this.pixelBuffer = v.pixelBuffer;
        this.frames = v.frames;
        this.totalFrames = v.frames.length;
        this.sFrameRate = v.frames[this.totalFrames - 1] / this.totalFrames;
        [width, height] = [v.width, v.height];
        hasParse = true;
      }
    }
    if(!hasParse) {
      let result = await fetch(handleAssetsUrl(this.picUrl), {
        method: 'get',
        responseType: 'arraybuffer'
      });
      if(!result.ok) return;
      let gifBuffer = await result.arrayBuffer();

      let reader = new GifReader(new Uint8Array(gifBuffer));
      let frames = reader.frames;
      [width, height] = [reader.width, reader.height];
      let pixelBuffer = new Uint8ClampedArray(frames.length * width * height * 4);
      let frameArr = new Uint8ClampedArray(width * height * 4);
      let last = { disposal: 0 };
      let rate = this.frameRate;

      this.frames[0] = (frames[0].delay || 6) / 100 * rate;
      for (let i = 0; i < frames.length; i++) {
        if (i !== 0) {
          this.frames[i] = (frames[i].delay || 6) / 100 * rate + this.frames[i - 1];
          last = frames[i - 1];
        }
        if (last.disposal === 2) {
          if (!last.x && !last.y && last.width === width && last.height === height) {
            frameArr = new Uint8ClampedArray(width * height * 4);
          } else {
            let arrB = new Uint8ClampedArray(last.width * 4);
            for (let j = 0; j < last.height; j++) {
              frameArr.set(arrB, ((last.y + j) * width + last.x) * 4);
            }
          }
        } else if (last.disposal === 3) {
          frameArr = new Uint8ClampedArray(width * height * 4);
        }
        reader.decodeAndBlitFrameRGBA(i, frameArr);
        pixelBuffer.set(frameArr, i * width * height * 4);
      }
      frameArr = null;
      this.pixelBuffer = pixelBuffer;
      SpriteEle.gifBuffer.push({
        url: this.url,
        index: 0,
        pixelBuffer: pixelBuffer,
        frames: this.frames,
        width: width,
        height: height
      });
      this.totalFrames = this.frames.length;
      this.sFrameRate = this.frames[this.totalFrames - 1] / this.totalFrames;
      reader = null;
    }
    [this.cWidth, this.cHeight] = [width, height];
  }
  play(frame) {
    if(!this.isGif) return;
    let total = this.frames.length - 1,
      i = 0;
    frame = frame % this.frames[total];
    for (i in this.frames) {
      if (frame < this.frames[i]) break;
    }
    this.imageData.data.set(this.pixelBuffer.subarray(i * this.cWidth *  this.cHeight * 4, (+i + 1) *  this.cWidth *  this.cHeight * 4));
    this.canvas.getContext('2d').putImageData(this.imageData, 0, 0);
  }
  _id2unique(svg) {
    svg.find('[id]').forEach((value) => {
      let new_id = SpriteEle.makeid();
      value.attr('id', new_id);
    });
  }
  _style2cssinline(svg) {
    let styletag = svg.find('style')[0];
    if (!styletag) return;

    // 兼容firefox和chrome
    let _html = styletag.node.innerHTML || styletag.node.textContent;
    let styleObj = this._getStyleObj(_html);

    svg.find('*').forEach((value) => {
      let classname = value.attr('class');
      if (!classname) return;
      let cls = classname.split(' ');
      cls.forEach((c) => {
        let cobj = styleObj[c.trim()],
          style = value.style() || '';
        if (cobj) {
          value.attr('style', style ? style + ';' + cobj : cobj);
        }
      });
      value.attr('class', null);
    });
  }
  _getStyleObj(str) {
    let arr = str ? str.match(/[\S\s]+?\}/g) : [],
      classobj = {};
    arr.forEach((a) => {
      let split = a.split('{');
      let sname = split[0].trim(),
        content = split[1].split('}')[0].replace(/\n/g, '').trim();
        // 有逗号分隔的情况
      if (sname.indexOf(',') !== -1) {
        let c = sname.split(',');
        c.forEach((i) => {
          i = i.trim();
          let attr = i.substr(1);
          if (i[0] === '.') {
            classobj[attr] = classobj[attr] ? classobj[attr] += ';' + content : content;
          }
        });
      } else {
        // class obj
        let attr = sname.substr(1);
        if (sname[0] === '.') {
          classobj[attr] = classobj[attr] ? classobj[attr] += ';' + content : content;
        }
      }
    });
    return classobj;
  }
  _calcMatrix(m) {
    let mx = Object.assign({}, m);
    if (m.rotate && !m.transform) {
      mx.transform = 'rotate(' + m.rotate + ' ' + (m.width / 2 + m.x) + ' ' + (m.height / 2 + m.y) + ')';
    } else if (m.rotate === 0) {
      mx.transform = 'rotate(0)';
    }
    return mx;
  }
  getThumbDom(frame) {
    let dom = super.getThumbDom(frame);
    if(dom) {
      let id = `frame-${SpriteEle.makeid()}-clip-path-thumb`;
      let clipPath = dom.querySelector('.frame-mask clipPath');
      clipPath.setAttribute('id', id);
      let g = dom.querySelector('.frame-image g');
      g.setAttribute('clip-path', `url(#${id})`);
      if(this.isGif) {
        let canvas = dom.querySelector('.frame-image canvas');
        canvas.getContext('2d').putImageData(this.imageData, 0, 0);
      }
      return dom;
    } else {
      return null;
    }
  }
  cloneDom(){
    let dom = super.cloneDom();
    if(dom) {
      let clone = this.dom.cloneNode(true);
      this.dealCloneDom(clone);
      let id = `frame-${SpriteEle.makeid()}-clip-path-thumb`;
      let clipPath = clone.querySelector('.frame-mask clipPath');
      clipPath.setAttribute('id', id);
      let g = clone.querySelector('.frame-image g');
      g.setAttribute('clip-path', `url(#${id})`);
      if(this.isGif) {
        let canvas = clone.querySelector('.frame-image canvas');
        canvas.getContext('2d').putImageData(this.imageData, 0, 0);
      }
      dom.appendChild(clone);
    }
    return dom;
  }
}
class VideoSprite extends SpriteEle{
  constructor(option) {
    super(option);
    this.url = '';
    this.loop = false;
    this.repeatTimes = 3;
    this.startTime = 0;
    this.cutDuration = 0;
    this.volume = 50;
    this.poster = '';

    this.iniWidth = 0;
    this.iniHeight = 0;
    this.video = null;
    this.videoDuration = 0;
    this.isPlay = false;
    this.timeout = null;
    this.nowLoop = 0;
  }
  async fromJson(json) {
    await super.fromJson(json);
    ({
      url: this.url,
      isLoop: this.loop,
      numberOfLoops: this.repeatTimes,
      videoStartTime: this.startTime,
      videoDuration: this.cutDuration,
      volume: this.volume,
      poster: this.poster
    } = json);
    await this.effect.fromJson(json);
  }
  async initDom(dom) {
    super.initDom(dom);
    let cutStart = this.startTime;
    let cutEnd = this.startTime + this.cutDuration;
    let video = document.createElement('video');
    video.src = `${handleAssetsUrl(this.url)}#t=${cutStart},${cutEnd}`;
    video.volume = this.volume / 100;
    video.crossOrigin = true;
    video.setAttribute('class', 'video-sprite-video');
    video.setAttribute('x5-video-player-type', 'h5-page');
    video.setAttribute('x5-video-player-fullscreen', 'false');
    video.setAttribute('webkit-playsinline', 'true');
    video.setAttribute('playsinline', 'true');

    let loadPro = new Promise(resolve => {
      video.addEventListener('loadedmetadata', loadedmetadata);
      video.addEventListener('error', loadError);
      video.addEventListener('canplay', canPlay);
      function canPlay () {
        video.removeEventListener('canplay', canPlay)
        video.removeEventListener('loadedmetadata', loadedmetadata);
        video.removeEventListener('error',loadError);
        resolve(true);
      }
      function loadedmetadata(){
        video.removeEventListener('canplay', canPlay)
        video.removeEventListener('loadedmetadata', loadedmetadata);
        video.removeEventListener('error',loadError);
        resolve(true);
      }
      function loadError() {
        video.removeEventListener('canplay', canPlay)
        video.removeEventListener('loadedmetadata', loadedmetadata);
        video.removeEventListener('error',loadError);
        resolve(false);
      }
      setTimeout(() => {
        resolve(true)
      }, 500)
    });
    let ok = await loadPro;
    if(!ok) return;

    this.iniWidth = video.videoWidth;
    this.iniHeight = video.videoHeight;
    this.video = video;
    this.videoDuration = video.duration;
    this.setFilter(video);
    dom.appendChild(video);
    await this.effect.initDom();
    this.loaded = true;
  }
  play(frame, isPlay){
    let timeObj = this.frameToTime(frame);
    if(isPlay) {
      if(this.isPlay) {
        if(timeObj.canPlay) {
          if(this.video.currentTime > timeObj.time + 0.5) {
            this.video.currentTime = timeObj.time;
          }
        } else {
          this.video.pause();
          this.isPlay = false;
          this.video.currentTime = timeObj.time;
        }
      } else {
        if(timeObj.canPlay) {
          this.video.currentTime = timeObj.time;
          this.video.play();
          this.isPlay = true;
        } else {
          this.video.currentTime = timeObj.time;
        }
      }
    } else {
      if(this.isPlay) {
        this.video.pause();
        this.video.currentTime = timeObj.time;
        this.isPlay = false;
      } else {
        this.video.currentTime = timeObj.time;
      }
    }
  }
  initVideo(frame) {
    frame = Math.max(0, frame - this.effect.enterAnim.startF);
    frame = Math.min(this.effect.exitAnim.startF - this.effect.enterAnim.startF, frame);
    let obj = this.frameToTime(frame);
    if(this.isPlay) {
      this.video.pause();
      this.isPlay = false;
    }
    this.video.currentTime = obj.time;
  }
  frameToTime(frame) {
    let data = {
      time: 0,
      canPlay: false
    };
    let time = frame / this.frameRate;
    let n = Math.floor(time / this.cutDuration);
    if(!this.loop && this.repeatTimes <= n) {
      data.time = this.startTime + this.cutDuration;
      data.canPlay = false;
    } else {
      data.time = this.startTime + time % this.cutDuration;
      data.canPlay = true;
    }
    return data;
  }
  getThumbDom(frame) {
    let dom = super.getThumbDom(frame);
    if(dom) {
      let video = dom.getElementsByTagName('video')[0];
      video.currentTime = this.video.currentTime;
      return dom;
    } else {
      return null;
    }
  }
  cloneDom(){
    let dom = super.cloneDom();
    if(dom) {
      let clone = this.dom.cloneNode(true);
      this.dealCloneDom(clone);
      let video = clone.getElementsByTagName('video')[0];
      video.currentTime = this.video.currentTime;
      dom.appendChild(clone);
    }
    return dom;
  }
}
class RichTextSprite extends SpriteEle{
  constructor(option) {
    super(option);
    this.html = '<p></p>';
    this.lineHeight = 1;
    this.versionAnyway = 'Horizontal';
    this.fontList = [];

    this.forVip = [];
  }
  async fromJson(json) {
    await super.fromJson(json);
    ({
      html: this.html,
      lineSpacing: this.lineHeight,
      versionAnyway: this.versionAnyway,
      fontList: this.fontList
    } = json);
    if (json.resourceIds && json.resourceIds.length) {
      json.resourceIds.forEach(v => {
        this.forVip.push({
          id: v,
          fileType: 15
        });
      });
    }
    await this.effect.fromJson(json);
  }
  async initDom(dom) {
    super.initDom(dom);
    let textDom = document.createElement('div');
    for (let i in this.fontList) {
      await loadFont(this.fontList[i]);
    }
    textDom.innerHTML = this.html;
    textDom.style.whiteSpace = 'pre-wrap';
    textDom.style.fontSize = '40px';
    textDom.style.fontFamily = '"1526467728442.TTF"';
    textDom.style.lineHeight = this.lineHeight;
    textDom.style.wordBreak = 'break-word';
    textDom.style.textAlign = 'center';

    if (this.versionAnyway === 'Vertical') {
      // 竖版
      textDom.style.width = 'auto';
      textDom.style.height = `${this.height}px`;
      textDom.style.writingMode = 'vertical-rl';
    } else {
      textDom.style.width = `${this.width}px`;
      textDom.style.height = 'auto';
      textDom.style.writingMode = 'inherit';
    }
    this.setFilter(textDom);
    dom.appendChild(textDom);
    await this.effect.initDom();
    this.loaded = true;
  }
  cloneDom(){
    let dom = super.cloneDom();
    if(dom) {
      let clone = this.dom.cloneNode(true);
      this.dealCloneDom(clone);
      dom.appendChild(clone);
    }
    return dom;
  }
}
class ChartSprite extends SpriteEle{
  constructor(option) {
    super(option);
  }
  async fromJson(json) {
    await super.fromJson(json);
    // ({} = json);
  }
}

class Effect {
  constructor(sprite){
    this.sprite = sprite;
    this.frameRate = sprite.frameRate;
    this.enterAnim = null;
    this.enterHand = null;
    this.exitAnim = null;
    this.exitHand = null;
    this.stayAnim = null;
    this.pathAnim = null;

    this.initData = null;
    this.enterObject = null;
    this.exitObject = null;
    this.stayObject = null;
    this.pathObject = null;

    this.resetEnterStart = false;
    this.resetEnterEnd = false;
    this.specialEnter = false;
    this.resetExitEnd = false;
  }
  async fromJson(json){
    let stay = json.stayEffect,
      enter = json.enterEffect,
      exit = json.exitEffect,
      animGraphs = stay.animationGraphs ?
        stay.animationGraphs[0] : null,
      attachAnim = stay.attachAnim ?
        stay.attachAnim[0] : null;
    this.enterAnim = {
      type: Capitalize(enter.type),
      direction: enter.direction,
      easing: enter.easing || 0,
      drawDuration: enter.drawDuration ? enter.drawDuration * 1000 : 0,
      start: json.startTime * 1000,
      end: (json.startTime + enter.duration) * 1000,
      writehand: enter.writehand ? Object.assign({}, enter.writehand, {url: handleAssetsUrl(enter.writehand.url)}) : null
    };
    this.enterHand = enter.hand ? Object.assign({show: false, top: 0, left: 0, rotate: this.sprite.rotate}, enter.hand) : null;
    this.exitAnim = {
      type: exit.type,
      direction: exit.direction,
      easing: exit.easing || 0,
      start: this.enterAnim.end + stay.duration * 1000,
      end: this.enterAnim.end + (stay.duration + exit.duration) * 1000
    };
    this.exitHand = exit.hand ? Object.assign({show: false, top: 0, left: 0, rotate: this.sprite.rotate}, exit.hand) : null;
    this.enterAnim.startF = Effect.ms2fps(this.enterAnim.start, this.frameRate);
    this.enterAnim.endF = Effect.ms2fps(this.enterAnim.end, this.frameRate);
    this.exitAnim.startF = Effect.ms2fps(this.exitAnim.start, this.frameRate);
    this.exitAnim.endF = Effect.ms2fps(this.exitAnim.end, this.frameRate);
    this.initData = this.sprite.getInitData();

    if(attachAnim) {
      this.stayAnim = Object.assign({ type: attachAnim.type }, JSON.parse(attachAnim.data));
      this.stayAnim.start = this.enterAnim.endF;
      this.stayAnim.end = this.exitAnim.startF;
      switch (this.stayAnim.type) {
        case 'Whirl':
          this.stayObject = new WhirlStayEffect(this.sprite, this.initData, this.stayAnim);
          break;
        case 'Shake':
          this.stayObject = new ShakeStayEffect(this.sprite, this.initData, this.stayAnim);
          break;
      }
    }
    if(animGraphs) {
      this.pathAnim = {
        // 开始时间为元素入场结束时间
        type: animGraphs.type,
        easing: animGraphs.easing,
        loop: animGraphs.loop,
        dur: Effect.ms2fps((animGraphs.duration < 0.5 ? 0.5 : animGraphs.duration) * 1000, this.frameRate),
        stayStart: this.enterAnim.endF,
        stayEnd: this.exitAnim.startF,
        target: {
          x: animGraphs.toBounds.x,
          y: animGraphs.toBounds.y,
          w: animGraphs.toBounds.width,
          h: animGraphs.toBounds.height,
          rotate: animGraphs.toRotation,
          opacity: animGraphs.toOpacity,
          fillColor: animGraphs.toFillColor,
          textColor: animGraphs.toTextColor
        },
        info: animGraphs.info ? {
          width: animGraphs.info.width,
          height: animGraphs.info.height,
          rotate: animGraphs.info.rotate,
          ccw: animGraphs.info.ccw,
          path: animGraphs.path,
          close: animGraphs.info.close,
          freePathType: animGraphs.info.freePathType,
          points: animGraphs.type === 'FreePath' ? animGraphs.info.points : []
        } : null,
        path: animGraphs.path
      };
      switch (animGraphs.type) {
        case 'Path':
          this.pathObject = new PathGraphEffect(this.sprite, this.initData, this.pathAnim);
          break;
        case 'Bessel':
          this.pathObject = new BesselGraphEffect(this.sprite, this.initData, this.pathAnim);
          break;
        case 'Ellipse':
          this.pathObject = new EllipseGraphEffect(this.sprite, this.initData, this.pathAnim);
          break;
        case 'FreePath':
          this.pathObject = new FreePathGraphEffect(this.sprite, this.initData, this.pathAnim);
          break;
      }
    }

    switch (this.enterAnim.type) {
      case 'Hand':
        this.specialEnter = true;
        this.enterObject = new HandEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData);
        break;
      case 'Draw':
        this.enterObject = new DrawEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData);
        break;
      case 'Smear':
        this.specialEnter = true;
        this.enterObject = new SmearEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData);
        break;
      case 'Type':
        this.specialEnter = true;
        this.enterObject = new TypeEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData);
        break;
      case 'Roll':
        this.specialEnter = true;
        this.enterObject = new RollEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData);
        break;
      case 'Bounce':
        this.specialEnter = true;
        this.enterObject = new BounceEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData);
        break;
      case 'LeftIn':
      case 'RightIn':
      case 'UpIn':
      case 'DownIn':
        this.enterObject = new MoveEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData, this.enterAnim.type);
        break;
      case 'Write':
        this.specialEnter = true;
        this.enterObject = new WriteEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData, this.enterAnim.type);
        break;
      case 'Appear':
        this.specialEnter = true;
        this.enterObject = new AppearEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData);
        break;
      case 'PopIn':
        this.enterObject = new PopInEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData);
        break;
      case 'FadeIn':
        this.enterObject = new FadeInEnterEffect(this.sprite, this.enterAnim, this.enterHand, this.initData);
        break;
      case 'None':
      default:
        this.enterObject = new NoneEnterEffect(this.sprite);
        break;
    }
    let startData = Object.assign({}, this.initData);
    if(this.stayObject) {
      this.stayObject.initInfo();
      startData = Object.assign(startData, this.stayObject.finally);
    } else if(this.pathObject) {
      this.pathObject.initInfo();
      startData = Object.assign(startData, this.pathObject.finally);
    }
    switch (this.exitAnim.type) {
      case 'LeftOut':
      case 'RightOut':
      case 'UpOut':
      case 'DownOut':
        this.exitObject = new MoveExitEffect(this.sprite, this.exitAnim, this.exitHand, this.initData, startData);
        break;
      case 'PopOut':
        this.exitObject = new PopOutExitEffect(this.sprite, this.exitAnim, this.exitHand, this.initData);
        break;
      case 'FadeOut':
        this.exitObject = new FadeOutExitEffect(this.sprite, this.exitAnim, this.exitHand, this.initData, startData);
        break;
      case 'Smear':
        this.exitObject = new SmearExitEffect(this.sprite, this.exitAnim, this.exitHand, this.initData, startData);
        break;
      case 'None':
      default:
        this.exitObject = new NoneExitEffect(this.sprite);
        break;
    }
  }
  async initDom() {
    await this.enterObject.initDom();
    await this.exitObject.initDom();
  }
  play(frame, isPlay) {
    let s = this.sprite,
      enStart = this.enterAnim.startF,
      enEnd = this.enterAnim.endF,
      exStart = this.exitAnim.startF,
      exEnd = this.exitAnim.endF;
    if (!s.loaded) return;
    if(frame < enStart) {
      // 入场之前
      s.show = false;
      if(!this.resetEnterStart) {
        this.enterObject.resetStart();
        this.resetEnterStart = true;
      }
      if(!this.resetExitEnd) {
        this.exitObject.resetEnd();
        this.resetExitEnd = true;
      }
    } else if (frame >= enStart && frame < enEnd) { // 入场阶段
      if(this.pathObject && !this.pathObject.reset) this.pathObject.resetPath();
      if(this.stayObject && !this.stayObject.reset) this.stayObject.resetStay();
      s.show = true;
      this.enterObject.play(frame - enStart);
      s.play(0, false);
      this.resetEnterStart = false;
      this.resetEnterEnd = false;
    } else if (frame >= enEnd && frame <= exStart) { // 停留阶段
      s.show = true;
      s.play(frame - enEnd, isPlay);
      if(this.specialEnter && frame - enStart < this.enterObject.specialTime) {
        if(!this.resetEnterStart) {
          this.enterObject.resetStart();
          this.resetEnterStart = true;
        }
        this.enterObject.play(frame - enStart);
      } else {
        if(!this.resetEnterEnd) {
          this.enterObject.resetEnd();
          this.resetEnterEnd = true;
        }
        this.stayObject && this.stayObject.play(frame - enEnd);
        this.pathObject && this.pathObject.play(frame - enEnd);
      }
    } else if (frame > exStart && frame <= exEnd) { // 退场阶段
      s.show = true;
      s.play(exStart - enEnd, false);
      this.exitObject.play(frame - exStart);
      this.resetExitEnd = false;
    } else if(frame > exEnd) {
      if(!this.resetExitEnd) {
        this.exitObject.resetEnd();
        this.resetExitEnd = true;
      }
      s.show = false;
      this.enterHand && (this.enterHand.show = false);
    }
  }
  initReset() {
    this.resetEnterStart = false;
    this.resetEnterEnd = false;
    this.resetExitEnd = false;
  }
  static ms2fps (ms, frameRate) {
    // 根据当前动画时间求出当前帧
    let t = 1000 / frameRate; // 每帧需要的时间
    return Math.ceil(ms / t);
  }
  static WRITE_HAND_SCALE = 1.8
}

class EnterEffect{
  constructor(sprite, enterAnim, enterHand, initData) {
    this.sprite = sprite;
    this.enterAnim = enterAnim;
    this.enterHand = enterHand;
    this.initData = initData;
    this.frameRate = sprite.frameRate;
    this.enterOffset = null;
    this.specialTime = 0;
  }
  async initDom(){
    if(this.enterHand) {
      let imgPro = new Promise((resolve) => {
        let img = new Image();
        img.onload = () => {
          resolve(img);
        };
        img.onerror = () => {
          resolve(false);
        };
        img.src = handleAssetsUrl(this.enterHand.url);
      });
      let img = await imgPro;
      this.enterHand.img = img;
    }
  }
  resetStart(){}
  resetEnd(){}
  static getPointByTransform(origin, m) {
    if (!m) return origin;
    let p = new Point(origin.x, origin.y);
    return p.transform(new Matrix(m.a, m.b, m.c, m.d, m.e, m.f));
  }
}
class NoneEnterEffect extends EnterEffect{
  constructor(sprite) {
    super(sprite);
  }
  play(){
    this.sprite.show = false;
  }
}
class MoveEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData, type) {
    super(sprite, enterAnim, enterHand, initData);
    this.type = type;
  }
  async initDom() {
    await super.initDom();
    this.enterOffset = this[`get${this.type}Data`]();
  }
  getLeftInData(){
    let offset = {
      left :- this.initData.width
    };
    this.enterHand && (this.enterHand.rotate = 0);
    return offset;
  }
  getRightInData(){
    let offset = {
      left : 1920
    };
    this.enterHand && (this.enterHand.rotate = 0);
    return offset;
  }
  getDownInData(){
    let offset = {
      top : 1080
    };
    this.enterHand && (this.enterHand.rotate = 0);
    return offset;
  }
  getUpInData(){
    let offset = {
      top : -this.initData.height
    };
    this.enterHand && (this.enterHand.rotate = 0);
    return offset;
  }
  play(frameOff){
    this[`play${this.type}`](frameOff);
  }
  playLeftIn(frameOff){
    let distance = this.initData.left - this.enterOffset.left;
    this.sprite.left = EasingAnim[this.enterAnim.easing](frameOff, this.enterOffset.left, distance, 0.5 * this.frameRate);
    this.moveHandPosition();
  }
  playRightIn(frameOff){
    let distance = this.initData.left - this.enterOffset.left;
    this.sprite.left = EasingAnim[this.enterAnim.easing](frameOff, this.enterOffset.left, distance, 0.5 * this.frameRate);
    this.moveHandPosition();
  }
  playDownIn(frameOff){
    let distance = this.initData.top - this.enterOffset.top;
    this.sprite.top = EasingAnim[this.enterAnim.easing](frameOff, this.enterOffset.top, distance, 0.5 * this.frameRate);
    this.moveHandPosition();
  }
  playUpIn(frameOff){
    let distance = this.initData.top - this.enterOffset.top;
    this.sprite.top = EasingAnim[this.enterAnim.easing](frameOff, this.enterOffset.top, distance, 0.5 * this.frameRate);
    this.moveHandPosition();
  }
  resetStart() {
    let s = this.sprite;
    this.enterOffset.left && (s.left = this.initData.left);
    this.enterOffset.top && (s.top = this.initData.top);
    this.enterHand && (this.enterHand.show = false);
  }
  resetEnd(){
    let s = this.sprite;
    s.left = this.initData.left;
    s.top = this.initData.top;
    this.enterHand && (this.enterHand.show = false);
  }
  moveHandPosition(){
    if(this.enterHand) {
      let s = this.sprite;
      this.enterHand.show = true;
      // if (this.enterHand.img && this.exitHand.img.style) {
      //   this.enterHand.img.style.maxWidth = 'initial';
      // }
      this.enterHand.top = s.top + s.height / 2 - this.enterHand.anchorPointY;
      this.enterHand.left = s.left + s.width / 2 - this.enterHand.anchorPointX;
    }
  }
}
class SmearEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    // e - right东， w - left西， s - down南， n - up北
    let h1, v1, h2, v2, w, h, start, dur, ini = this.initData;
    switch (this.enterAnim.direction) {
      case 'w':
        w = ini.width * 2;
        h = ini.height;
        h1 = 'right';
        v1 = 'bottom';
        h2 = 'left';
        v2 = 'bottom';
        start = 0;
        dur = - ini.width;
        break;
      case 'e':
        w = ini.width * 2;
        h = ini.height;
        h1 = 'left';
        v1 = 'bottom';
        h2 = 'right';
        v2 = 'bottom';
        start = - ini.width;
        dur = ini.width;
        break;
      case 'n':
        w = ini.width;
        h = ini.height * 2;
        h1 = 'left';
        v1 = 'bottom';
        h2 = 'left';
        v2 = 'top';
        start = 0;
        dur = -ini.height;
        break;
      case 's':
        w = ini.width;
        h = ini.height * 2;
        h1 = 'left';
        v1 = 'top';
        h2 = 'left';
        v2 = 'bottom';
        start = -ini.height;
        dur = ini.height;
        break;
    }
    this.enterOffset =  {
      start: start,
      dur: dur,
      maskSize: `${w}px ${h}px`,
      totalFrame: 0.5 * this.frameRate,
      maskImage: `-webkit-gradient(linear, ${h1} ${v1}, ${h2} ${v2}, color-stop(0.00, rgba(0,0,0,1)),color-stop(0.45, rgba(0,0,0,1)),color-stop(0.50, rgba(0,0,0,0)),color-stop(0.55, rgba(0,0,0,0)),color-stop(1.00, rgba(0,0,0,0)))`
    };
  }
  play(frameOff){
    let offset = this.enterOffset,
      dom = this.sprite.dom,
      left = 0,
      top = 0;
    let dx = EasingAnim[0](frameOff, offset.start, offset.dur, offset.totalFrame);
    switch(this.enterAnim.direction) {
      case 'e':
      case 'w':
        left = dx;
        top = 0;
        break;
      case 'n':
      case 's':
        top = dx;
        left = 0;
        break;
    }
    if(!dom.style.webkitMaskImage || dom.style.webkitMaskImage === 'none') {
      dom.style.webkitMaskImage = this.enterOffset.maskImage;
      dom.style.webkitMaskSize = this.enterOffset.maskSize;
    }
    dom.style.webkitMaskPosition = `${left}px ${top}px`;
  }
  resetStart() {
    let dom = this.sprite.dom;
    dom.style.webkitMaskImage = this.enterOffset.maskImage;
    dom.style.webkitMaskSize = this.enterOffset.maskSize;
  }
  resetEnd() {
    let dom = this.sprite.dom;
    dom.style.webkitMaskImage = '';
    dom.style.webkitMaskSize = '';
    dom.style.webkitMaskPosition = '';
  }
}
class PopInEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    this.enterOffset =  {
      totalFrame: 0.5 * this.frameRate
    };
  }
  play(frameOff){
    this.sprite.scale = EasingAnim[3](frameOff, 0.01, 1, this.enterOffset.totalFrame);
  }
  resetStart() {
    this.sprite.scale = 0.01;
  }
  resetEnd() {
    this.sprite.scale = 1;
  }
}
class FadeInEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    this.enterOffset =  {
      totalFrame: 0.5 * this.frameRate
    };
  }
  play(frameOff){
    this.sprite.opacity = EasingAnim[0](frameOff, 0, this.initData.opacity, this.enterOffset.totalFrame);
  }
  resetStart() {
    this.sprite.opacity = 0;
  }
  resetEnd() {
    this.sprite.opacity = this.initData.opacity;
  }
}
class HandEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    this.sprite.setHandDom();
    let viewbox = this.sprite.svg.viewbox();
    let p = this.svgHandPosition(0, this.sprite.items[0], viewbox, {anchorPointX: 0, anchorPointY: 0});
    this.specialTime = Effect.ms2fps(this.enterAnim.drawDuration, this.frameRate);
    this.enterOffset = {
      drawDuration: this.specialTime,
      fadeDuration: this.enterAnim.drawDuration <= 500 ? 0 : this.frameRate / 2,
      halfF: this.frameRate / 2,
      enterDur: this.enterAnim.endF - this.enterAnim.startF,
      viewbox: viewbox,
      startL: p.x,
      startT: 1080,
      durT: p.y - 1080
    };
    this.specialTime += this.frameRate / 2;
  }
  play(frameOff){
    let s = this.sprite;
    let offset = this.enterOffset;

    if(frameOff < offset.enterDur) {
      // 手势入场动画
      if(this.enterHand) {
        this.enterHand.show = true;
        this.enterHand.left = offset.startL;
        this.enterHand.top = EasingAnim[0](frameOff, offset.startT, offset.durT, offset.halfF);
      }
      // todo
    } else if(frameOff < offset.drawDuration + offset.enterDur - offset.fadeDuration) {
      for (let i=0; i<s.items.length; i++) {
        let item = s.items[i];
        if(item.endF < frameOff) {
          item.el.attr({ 'stroke-dashoffset': 0, opacity: 1 });
        } else if (item.startF < frameOff) {
          let length = item.length * (frameOff - item.startF) / Math.max(item.endF - item.startF, 0);
          item.el.attr('stroke-dashoffset', Math.max(0, item.length - length));
          // 手势
          if (this.enterHand) {
            this.enterHand.show = true;
            let p = this.svgHandPosition(length, item, offset.viewbox, this.enterHand);
            this.enterHand.left = p.x;
            this.enterHand.top = p.y;
          }
        } else {
          item.el.attr('stroke-dashoffset', -item.length);
        }
      }
    } else if(frameOff < offset.drawDuration + offset.enterDur) {
      // svg颜色淡入
      let _o = 1;
      if (offset.fadeDuration > 0) {
        _o = Math.min((offset.fadeDuration - offset.drawDuration - offset.enterDur + frameOff)/offset.fadeDuration, 1);
      }
      s.svg.show();
      s.svg.find('path').css('fill-opacity', _o);
      this.enterHand && (this.enterHand.show = false);
    }
  }
  svgHandPosition(len, item, vb, enterHand){
    if(!item) return {
      x: 0,
      y: 0
    };
    let point = item.el.pointAt(len);
    let si = this.initData;
    point = EnterEffect.getPointByTransform(point, item.matrix);
    if (item.transform) {
      point.x -= item.transform.x;
      point.y -= item.transform.y;
    }
    let ratioW = vb.width / si.width;
    let ratioH = vb.height / si.height;
    point.x = (point.x - vb.x) / ratioW;
    point.y = (point.y - vb.y) / ratioH;
    let sc = {
      x: si.left + si.width / 2,
      y: si.top + si.height / 2
    };
    let v1 = {
      x: - si.width / 2 + point.x,
      y: - si.height / 2 + point.y
    };
    let angle = si.rotate * Math.PI / 180;
    return {
      x: v1.x * Math.cos(angle) - v1.y * Math.sin(angle) + sc.x - enterHand.anchorPointX,
      y: v1.x * Math.sin(angle) + v1.y * Math.cos(angle) + sc.y - enterHand.anchorPointY
    };
  }
  resetStart() {
    let s = this.sprite;
    s.svg.hide();
    s.svg.find('path').map(v => v.css('fill-opacity', 0));
    s.playerSvg.show();
    for (let i=0; i<s.items.length; i++) {
      let item = s.items[i];
      item.el.attr('stroke-dashoffset', -item.length);
    }
    this.enterHand && (this.enterHand.show = false);
  }
  resetEnd() {
    let s = this.sprite;
    s.svg.find('path').css('fill-opacity', 1);
    s.svg.show();
    s.playerSvg.hide();
    this.enterHand && (this.enterHand.show = false);
  }
}
class DrawEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    let s = this.sprite;
    let length = await s.drawInitDom();
    this.enterOffset = {
      halfF: this.frameRate / 2,
      length: length
    };
  }
  play(frameOff){
    let s = this.sprite;
    let offset = this.enterOffset;
    let length = offset.length * frameOff / offset.halfF;
    s.drawPath.attr('stroke-dashoffset', offset.length - length);
    if (this.enterHand) {
      this.enterHand.show = true;
      let p = this.svgHandPosition(length, {el: s.drawPath}, {x:0, y:0, width: this.initData.width, height: this.initData.height});
      this.enterHand.left = p.x;
      this.enterHand.top = p.y;
    }
  }
  resetStart() {
    this.sprite.drawPath.attr('stroke-dashoffset', this.enterOffset.length);
    this.enterHand && (this.enterHand.show = false);
  }
  resetEnd() {
    this.sprite.drawPath.attr('stroke-dashoffset', 0);
    this.enterHand && (this.enterHand.show = false);
  }
  svgHandPosition(len, item, vb){
    let point = item.el.pointAt(len);
    let si = this.initData;
    point = EnterEffect.getPointByTransform(point, item.matrix);
    if (item.transform) {
      point.x -= item.transform.x;
      point.y -= item.transform.y;
    }
    let ratioW = vb.width / si.width;
    let ratioH = vb.height / si.height;
    point.x = (point.x - vb.x) / ratioW;
    point.y = (point.y - vb.y) / ratioH;
    let sc = {
      x: si.left + si.width / 2,
      y: si.top + si.height / 2
    };
    let v1 = {
      x: - si.width / 2 + point.x,
      y: - si.height / 2 + point.y
    };
    let angle = si.rotate * Math.PI / 180;
    return {
      x: v1.x * Math.cos(angle) - v1.y * Math.sin(angle) + sc.x - this.enterHand.anchorPointX,
      y: v1.x * Math.sin(angle) + v1.y * Math.cos(angle) + sc.y - this.enterHand.anchorPointY
    };
  }
}
class WriteEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    let s = this.sprite;
    let handObj = this.enterAnim.writehand || {
      url: '/static/animengine/img/writehand.png',
      armLeft: 136.7,
      armTop: 328.5
    }
    s.initSingeDom(1000);
    s._initWriteHand(handObj);
    let last = s.item[s.item.length - 1];
    this.specialTime = last.end + this.frameRate / 2;
    let handPosition = {
      out: (1080 - parseFloat(s.top)),
      first: {
        x: parseFloat(s.item[0].ele.style.left),
        y: parseFloat(s.item[0].ele.style.top)
      },
      last: {
        x: parseFloat(last.ele.style.left),
        y: parseFloat(last.ele.style.top)
      },
      halfF: this.frameRate / 2
    };
    let newlines = [];
    s.item.forEach((it, i, arr) => {
      if(it.isEndOfLine && arr[i+1]) {
        newlines.push({
          start: it.end,
          end: arr[i + 1].start,
          ox: parseFloat(it.ele.style.left) +
            TextSprite.getStringInfo(it.ele.innerText, it.ele.style.font, s.lineSpacing, s.font.fontSize).width,
          oy: parseFloat(it.ele.style.top),
          tx: parseFloat(arr[i + 1].ele.style.left),
          ty: parseFloat(arr[i + 1].ele.style.top)
        });
      }
    });

    this.enterOffset = {
      handPosition: handPosition,
      newlines: newlines
    };
  }
  play(frameOff){
    let s = this.sprite;
    let handDom = s.writehand.ele;
    let p = this.enterOffset.handPosition;
    if(s.item.length <= 0) return;
    let last = s.item[s.item.length - 1];
    if(frameOff < s.item[0].start) {
      handDom.style.display = 'block';
      handDom.style.left = `${p.first.x - 30 * Effect.WRITE_HAND_SCALE}px`;
      handDom.style.top = `${p.out - (((p.out + 70 * Effect.WRITE_HAND_SCALE) / p.halfF) * frameOff)}px`;
    } else if(frameOff > last.end && frameOff <= last.end + p.halfF) {
      handDom.style.display = 'block';
      handDom.style.left = `${p.last.x - 30 * Effect.WRITE_HAND_SCALE}px`;
      handDom.style.top = `${p.last.y + (((p.out + 70 * Effect.WRITE_HAND_SCALE) / p.halfF) * (frameOff - last.end))}px`;
    } else if(frameOff > last.end + p.halfF) {
      handDom.style.display = 'none';
      s.item.forEach(item => {
        item.ele.style.opacity = 1;
      })
      return;
    }
    s.item.forEach( (item, i) => {
      if(item.start > frameOff) {
        item.ele.style.opacity = 0;
      } else if (item.end < frameOff) {
        item.ele.style.opacity = 1;
      } else {
        item.ele.style.opacity = (frameOff - item.start) / (item.end - item.start);
        this.writeHandPosition(item, frameOff - item.start, i);
      }
      if(item.isEndOfLine && i < s.item.length - 1) {
        // 落在非字符动画区间时，则判断目前是处于哪个行末，找出下行起始的位置
        this.enterOffset.newlines.forEach(line => {
          if (frameOff > line.start && frameOff <= line.end) {
            let offx = line.ox - line.tx,
              offy = line.oy - line.ty,
              offframe = line.end - line.start,
              cframe = frameOff - line.start;

            let x = line.ox - (offx / offframe) * cframe,
              y = line.oy - (offy / offframe) * cframe;
            handDom.style.display = 'block';
            handDom.style.left = `${x - 30 * Effect.WRITE_HAND_SCALE}px`;
            handDom.style.top = `${y - 70 * Effect.WRITE_HAND_SCALE}px`;
          }
        });
      }
    });
  }
  writeHandPosition(item, frame, i) {
    let writehand = this.sprite.writehand;
    let f = item.end - item.start;
    let r = item.x + item.ele.clientWidth / f * frame;
    writehand.ele.style.display = 'block';
    writehand.ele.style.left = `${r - 30 * Effect.WRITE_HAND_SCALE}px`;
    writehand.ele.style.top = `${item.y + item.ele.clientHeight / 2 - 70 * Effect.WRITE_HAND_SCALE}px`;
    // 手掌及笔的摆动
    // 手掌最小摆动5度，最大20度，
    // 笔杆最大幅度2度，手掌最大幅度10
    // 字体最大限制为300，故比例为300 / 20 = 15 / 1
    let arm_range = this.sprite.font.fontSize / 15;
    arm_range = arm_range > 20 ? 20 : arm_range < 5 ? 5 : arm_range;
    if (i % 2 === 0) {
      writehand.palm.style.transform = `rotate(${arm_range / f * frame}deg)`;
      writehand.pen.style.transform = `rotate(${(0.5 - 0.5 / f) * frame}deg)`;
    } else {
      writehand.palm.style.transform = `rotate(${arm_range - arm_range / f * frame}deg)`;
      writehand.pen.style.transform = `rotate(${0.5 / f * frame}deg)`;
    }
  }
  resetStart() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 0;
    });
    this.sprite.writehand.ele.style.display = 'none';
  }
  resetEnd() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 1;
    });
    this.sprite.writehand.ele.style.display = 'none';
  }
}
class TypeEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    this.sprite.initSingeDom(0);
    this.specialTime = this.sprite.item[this.sprite.item.length - 1].end;
  }
  play(frameOff){
    let items = this.sprite.item;
    if(items.length <= 0) return;
    items.forEach( item => {
      if(item.start >= frameOff) {
        item.ele.style.opacity = 0;
      } else if (item.end <= frameOff) {
        item.ele.style.opacity = 1;
      } else {
        item.ele.style.opacity = (frameOff - item.start) / (item.end - item.start);
      }
    });
  }
  resetStart() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 0;
    });
  }
  resetEnd() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 1;
    });
  }
}
class AppearEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    this.sprite.initLineDom();
    if (this.sprite.item.length) {
      this.specialTime = this.sprite.item[this.sprite.item.length - 1].end;
    }
  }
  play(frameOff){
    let items = this.sprite.item;
    if(items.length <= 0) return;
    items.forEach( item => {
      if(item.start >= frameOff) {
        item.ele.style.opacity = 0;
      } else if (item.end <= frameOff) {
        item.ele.style.opacity = 1;
      } else {
        item.ele.style.opacity = (frameOff - item.start) / (item.end - item.start);
      }
    });
  }
  resetStart() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 0;
    });
  }
  resetEnd() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 1;
    });
  }
}
class RollEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    this.sprite.initSingeDom(200, 10);
    this.specialTime = this.sprite.item[this.sprite.item.length - 1].end;
  }
  play(frameOff){
    let items = this.sprite.item;
    if(items.length <= 0) return;
    items.forEach( item => {
      if(item.start >= frameOff) {
        item.ele.style.opacity = 0;
        item.ele.style.transform = '';
      } else if (item.end <= frameOff) {
        item.ele.style.opacity = 1;
        item.ele.style.transform = '';
      } else {
        let dur = item.end - item.start;
        let cf = frameOff - item.start;
        let op = cf / dur * 4;
        item.ele.style.opacity = op > 1 ? 1 : op;
        let cur = cf > dur / 1.5 ? dur / 1.5 : cf;
        let matrix = EasingAnim[2](cur, 200, -200, dur / 1.5);
        let rotate = EasingAnim[3](cf, 360, -360, dur, 1.1);
        item.ele.style.transform = `translate${this.sprite.versionAnyway === 'Vertical'? 'Y':'X'}(${matrix}px) rotate(${rotate}deg)`;
      }
    });
  }
  resetStart() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 0;
      item.ele.style.transform = '';
    });
  }
  resetEnd() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 1;
      item.ele.style.transform = '';
    });
  }
}
class BounceEnterEffect extends EnterEffect {
  constructor(sprite, enterAnim, enterHand, initData) {
    super(sprite, enterAnim, enterHand, initData);
  }
  async initDom() {
    await super.initDom();
    this.sprite.initSingeDom(0, 0, 120);
    this.specialTime = this.sprite.item[this.sprite.item.length - 1].end;
  }
  play(frameOff){
    let items = this.sprite.item;
    if(items.length <= 0) return;
    items.forEach( item => {
      if(item.start >= frameOff) {
        item.ele.style.opacity = 0;
        item.ele.style.transform = '';
      } else if (item.end <= frameOff) {
        item.ele.style.opacity = 1;
        item.ele.style.transform = '';
      } else {
        let dur = item.end - item.start;
        let cf = frameOff - item.start;
        let op = cf / dur * 2;
        item.ele.style.opacity = op > 1 ? 1 : op;
        let matrix = EasingAnim[4](cf, 60, -60, dur);
        item.ele.style.transform = this.sprite.versionAnyway === 'Vertical'? `translateX(${-matrix}px)`: `translateY(${matrix}px)`;
      }
    });
  }
  resetStart() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 0;
      item.ele.style.transform = '';
    });
  }
  resetEnd() {
    this.sprite.item.forEach( item => {
      item.ele.style.opacity = 1;
      item.ele.style.transform = '';
    });
  }
}

class ExitEffect {
  constructor(sprite, exitAnim, exitHand, initData, startData){
    this.sprite = sprite;
    this.exitAnim = exitAnim;
    this.exitHand = exitHand;
    this.startData = startData;
    this.initData = initData;
    this.frameRate = sprite.frameRate;
    this.exitOffset = null;
  }
  async initDom(){
    if(this.exitHand) {
      let imgPro = new Promise((resolve) => {
        let img = new Image();
        img.onload = () => {
          resolve(img);
        };
        img.onerror = () => {
          resolve(false);
        };
        img.src = handleAssetsUrl(this.exitHand.url);
      });
      let img = await imgPro;
      this.exitHand.img = img;
    }
  }
  resetEnd(){}
}
class NoneExitEffect extends ExitEffect {
  constructor(sprite) {
    super(sprite);
  }
  play(){
    this.sprite.show = false;
  }
}
class MoveExitEffect extends ExitEffect {
  constructor(sprite, exitAnim, exitHand, initData, startData) {
    super(sprite, exitAnim, exitHand, initData, startData);
    this.type = exitAnim.type;
  }
  async initDom() {
    await super.initDom();
    this.exitOffset = this[`get${this.type}Data`]();
    this.exitOffset.halfF = 0.5 * this.frameRate;
    this.exitHand && (this.exitHand.rotate = 0);
  }
  getLeftOutData(){
    let offset = {
      distance : -this.startData.width - this.startData.left
    };
    return offset;
  }
  getRightOutData(){
    let offset = {
      distance : 1920 - this.startData.left
    };
    return offset;
  }
  getDownOutData(){
    let offset = {
      distance : 1080 - this.startData.top
    };
    return offset;
  }
  getUpOutData(){
    let offset = {
      distance : -this.startData.height - this.startData.top
    };
    return offset;
  }
  play(frameOff){
    this[`play${this.type}`](frameOff, this.exitOffset);
  }
  playLeftOut(frameOff, offset){
    this.sprite.left = EasingAnim[this.exitAnim.easing](frameOff, this.startData.left, offset.distance, offset.halfF);
    this.moveHandPosition();
  }
  playRightOut(frameOff, offset){
    this.sprite.left = EasingAnim[this.exitAnim.easing](frameOff, this.startData.left, offset.distance, offset.halfF);
    this.moveHandPosition();
  }
  playDownOut(frameOff, offset){
    this.sprite.top = EasingAnim[this.exitAnim.easing](frameOff, this.startData.top, offset.distance, offset.halfF);
    this.moveHandPosition();
  }
  playUpOut(frameOff, offset){
    this.sprite.top = EasingAnim[this.exitAnim.easing](frameOff, this.startData.top, offset.distance, offset.halfF);
    this.moveHandPosition();
  }
  resetEnd(){
    let s = this.sprite;
    s.left = this.initData.left;
    s.top = this.initData.top;
    this.exitHand && (this.exitHand.show = false);
  }
  moveHandPosition(){
    if(this.exitHand) {
      let s = this.sprite;
      this.exitHand.show = true;
      // if (this.exitHand.img && this.exitHand.img.style) {
      //   this.exitHand.img.style.maxWidth = 'initial';
      // }
      this.exitHand.top = s.top + s.height / 2 - this.exitHand.anchorPointY;
      this.exitHand.left = s.left + s.width / 2 - this.exitHand.anchorPointX;
    }
  }
}
class PopOutExitEffect extends ExitEffect {
  constructor(sprite, exitAnim, exitHand, initData) {
    super(sprite, exitAnim, exitHand, initData);
  }
  async initDom() {
    await super.initDom();
    this.exitOffset =  {
      totalFrame: 0.5 * this.frameRate
    };
  }
  play(frameOff){
    this.sprite.scale = EasingAnim[5](frameOff, 1, -1, this.exitOffset.totalFrame);
  }
  resetEnd() {
    this.sprite.scale = 1;
  }
}
class FadeOutExitEffect extends ExitEffect {
  constructor(sprite, exitAnim, exitHand, initData, startData) {
    super(sprite, exitAnim, exitHand, initData, startData);
  }
  async initDom() {
    await super.initDom();
    this.exitOffset =  {
      totalFrame: 0.5 * this.frameRate
    };
  }
  play(frameOff){
    this.sprite.opacity = EasingAnim[0](frameOff, this.startData.opacity, 0 - this.startData.opacity, this.exitOffset.totalFrame);
  }
  resetEnd() {
    this.sprite.opacity = this.initData.opacity;
  }
}
class SmearExitEffect extends ExitEffect {
  constructor(sprite, exitAnim, exitHand, initData, startData) {
    super(sprite, exitAnim, exitHand, initData, startData);
  }
  async initDom() {
    await super.initDom();
    // e - right东， w - left西， s - down南， n - up北
    let h1, v1, h2, v2, w, h, start, dur, ini = this.startData;
    switch (this.exitAnim.direction) {
      case 'w':
        w = ini.width * 2;
        h = ini.height;
        h1 = 'left';
        v1 = 'bottom';
        h2 = 'right';
        v2 = 'bottom';
        start = 0;
        dur = - ini.width;
        break;
      case 'e':
        w = ini.width * 2;
        h = ini.height;
        h1 = 'right';
        v1 = 'bottom';
        h2 = 'left';
        v2 = 'bottom';
        start = - ini.width;
        dur = ini.width;
        break;
      case 'n':
        w = ini.width;
        h = ini.height * 2;
        h1 = 'left';
        v1 = 'top';
        h2 = 'left';
        v2 = 'bottom';
        start = 0;
        dur = -ini.height;
        break;
      case 's':
        w = ini.width;
        h = ini.height * 2;
        h1 = 'left';
        v1 = 'bottom';
        h2 = 'left';
        v2 = 'top';
        start = -ini.height;
        dur = ini.height;
        break;
    }
    this.exitOffset =  {
      start: start,
      dur: dur,
      maskSize: `${w}px ${h}px`,
      totalFrame: 0.5 * this.frameRate,
      maskImage: `-webkit-gradient(linear, ${h1} ${v1}, ${h2} ${v2}, color-stop(0.00, rgba(0,0,0,1)),color-stop(0.45, rgba(0,0,0,1)),color-stop(0.50, rgba(0,0,0,0)),color-stop(0.55, rgba(0,0,0,0)),color-stop(1.00, rgba(0,0,0,0)))`
    };
  }
  play(frameOff){
    let offset = this.exitOffset,
      dom = this.sprite.dom,
      left = 0,
      top = 0;
    let dx = EasingAnim[0](frameOff, offset.start, offset.dur, offset.totalFrame);
    switch(this.exitAnim.direction) {
      case 'e':
      case 'w':
        left = dx;
        top = 0;
        break;
      case 'n':
      case 's':
        top = dx;
        left = 0;
        break;
    }
    if(!dom.style.webkitMaskImage || dom.style.webkitMaskImage === 'none') {
      dom.style.webkitMaskImage = this.exitOffset.maskImage;
      dom.style.webkitMaskSize = this.exitOffset.maskSize;
    }
    dom.style.webkitMaskPosition = `${left}px ${top}px`;
  }
  resetEnd() {
    let dom = this.sprite.dom;
    dom.style.webkitMaskImage = '';
    dom.style.webkitMaskSize = '';
    dom.style.webkitMaskPosition = '';
  }
}

class StayEffect {
  constructor(sprite, initData, stayAnim){
    this.sprite = sprite;
    this.initData = initData;
    this.start = stayAnim.start;
    this.end = stayAnim.end;
    this.ini = null;
    this.finally = null;
    this.frameRate = sprite.frameRate;

    this.reset = true;
  }
  resetStay(){
    let s = this.sprite;
    ({top: s.top, left: s.left, rotate: s.rotate} = this.initData);
    this.reset = true;
  }
  static rotateWithPoint(a, o, deg) {
    //点a围绕o点旋转deg(顺时针)角度后的位置
    var b = {};
    deg = Math.PI/180 * deg;
    b.x = ( a.x - o.x ) * Math.cos(deg) - ( a.y - o.y ) * Math.sin(deg) + o.x;
    b.y = ( a.x - o.x ) * Math.sin(deg) + ( a.y - o.y ) * Math.cos(deg) + o.y;
    return b;
  }
}
class WhirlStayEffect extends StayEffect {
  constructor(sprite, initData, stayAnim) {
    super(sprite, initData, stayAnim);
    this.ccw = stayAnim.ccw ? -1 : 1;
    this.position = stayAnim.position;
    this.speed = stayAnim.speed;
  }
  initInfo() {
    let sInfo = this.initData;
    let a = {
      x: sInfo.left + sInfo.width / 2,
      y: sInfo.top + sInfo.height / 2
    };
    let o = {
      x: sInfo.left + this.position.left * sInfo.width,
      y: sInfo.top + this.position.top * sInfo.height
    };
    this.ini = {
      sCenter: a,
      center: StayEffect.rotateWithPoint(o, a, sInfo.rotate)
    };
    this.finally = this.whirlCalc(this.end - this.start);
  }
  play(frameOff) {
    let s = this.sprite;
    let data = this.whirlCalc(frameOff);
    ({top: s.top, left: s.left, rotate: s.rotate} = data);
    this.reset = false;
  }
  whirlCalc(frameOff) {
    let ini = this.ini;
    let rotate = frameOff * this.speed * 360 / this.frameRate * this.ccw;
    let calcP = StayEffect.rotateWithPoint(ini.sCenter, ini.center, rotate);
    return {
      top: calcP.y - this.initData.height / 2,
      left: calcP.x - this.initData.width / 2,
      rotate: (rotate + this.initData.rotate) % 360
    };
  }
}
class ShakeStayEffect extends StayEffect {
  constructor(sprite, initData, stayAnim) {
    super(sprite, initData, stayAnim);
    this.amplitude = stayAnim.amplitude;
    this.direction = stayAnim.direction;
    this.speed = stayAnim.speed;
  }
  initInfo() {
    let amp = 0;
    let sInfo = this.initData;
    let deg1 = Math.sin(Math.atan2(sInfo.height, sInfo.width)),
      deg2 = Math.sin((sInfo.rotate - this.direction) / 180 * Math.PI);
    if(Math.abs(deg1) < Math.abs(deg2)) {
      amp = sInfo.height / deg2;
    } else {
      amp = sInfo.width / Math.cos((sInfo.rotate - this.direction) / 180 * Math.PI);
    }
    this.ini = Math.abs(amp);
    this.finally = this.shakeCalc(this.end - this.start);
  }
  play(frameOff){
    let s = this.sprite;
    let data = this.shakeCalc(frameOff);
    ({top: s.top, left: s.left} = data);
    this.reset = false;
  }
  shakeCalc(frameOff) {
    let off = this.ini * this.amplitude * Math.sin(2*Math.PI*frameOff*this.speed/this.frameRate);
    let deg = this.direction / 180 * Math.PI;
    return {
      top: this.initData.top + off * Math.sin(deg),
      left: this.initData.left + off * Math.cos(deg)
    };
  }
}

class GraphEffect {
  constructor(sprite, initData, pathAnim){
    this.sprite = sprite;
    this.initData = initData;
    this.stayStart = pathAnim.stayStart;
    this.stayEnd = pathAnim.stayEnd;
    this.dur = pathAnim.dur;
    this.easing = pathAnim.easing || 0;
    this.loop = pathAnim.loop;
    this.target = pathAnim.target;
    this.info = pathAnim.info || {};
    this.frameRate = sprite.frameRate;

    this.pathDom = null;
    this.length = 0;
    this.finally = null;
    this.offset = null;

    this.reset = true;
    // 防止反复设置fillcolor---节省性能
    this.preFillColor = '';
  }
  createPathDom(){
    this.pathDom = AnimEditor.svgForPath.path(this.getPathStr());
    this.length = this.pathDom.length();
  }
  getOffset(){
    let t = this.target;
    let s = this.sprite;
    let ini = this.initData;
    let data = {
      w: t.w - ini.width,
      h: t.h - ini.height,
      r: t.rotate - ini.rotate,
      l: this.length,
      opacity: typeof(t.opacity) === 'number' ? t.opacity - ini.opacity : 0
    };
    if(s.type === 'Svg' && s.fileType === 28 && t.fillColor) {
      let rgb1 = GraphEffect.hex2rgb(s.fill),
        rgb2 = GraphEffect.hex2rgb(t.fillColor);
      data.rgb = [].concat(rgb1, rgb2);
      data.rgb[6] = rgb2[0] - rgb1[0];
      data.rgb[7] = rgb2[1] - rgb1[1];
      data.rgb[8] = rgb2[2] - rgb1[2];
      data.color = 'fillColor';
    }
    if(s.type === 'Text' && t.textColor) {
      var rgb1 =  GraphEffect.hex2rgb(s.font.color),
        rgb2 = GraphEffect.hex2rgb(t.textColor);
      data.rgb = [].concat(rgb1, rgb2);
      data.rgb[6] = rgb2[0] - rgb1[0];
      data.rgb[7] = rgb2[1] - rgb1[1];
      data.rgb[8] = rgb2[2] - rgb1[2];
      data.color = 'textColor';
    }
    this.offset = data;
  }
  offsetCalc(frameOff, ccw){
    let offset = this.offset;
    let ini = this.initData;
    let ea = PathEasing[this.easing];
    let data = {},
      position = null;
    if (!ccw) {
      position = this.pathDom.pointAt(ea(frameOff, 0, offset.l, this.dur));
      data.opacity = ea(frameOff, ini.opacity, offset.opacity, this.dur);
      if(offset.rgb) {
        let arr = [];
        arr[0] = ea(frameOff, offset.rgb[0], offset.rgb[6], this.dur);
        arr[1] = ea(frameOff, offset.rgb[1], offset.rgb[7], this.dur);
        arr[2] = ea(frameOff, offset.rgb[2], offset.rgb[8], this.dur);
        data[offset.color] =  GraphEffect.rgb2hex(arr);
      }
      data.width = ea(frameOff, ini.width, offset.w, this.dur);
      data.height = ea(frameOff, ini.height, offset.h, this.dur);
      data.rotate = ea(frameOff, ini.rotate, offset.r, this.dur);
    } else {
      position = this.pathDom.pointAt(ea(frameOff, offset.l, -offset.l, this.dur));
      data.opacity = ea(frameOff, ini.opacity + offset.opacity, -offset.opacity, this.dur);
      if(offset.rgb) {
        let arr = [];
        arr[0] = ea(frameOff, offset.rgb[3], -offset.rgb[6], this.dur);
        arr[1] = ea(frameOff, offset.rgb[4], -offset.rgb[7], this.dur);
        arr[2] = ea(frameOff, offset.rgb[5], -offset.rgb[8], this.dur);
        data[offset.color] =  GraphEffect.rgb2hex(arr);
      }
      data.width = ea(frameOff, this.target.w, -offset.w, this.dur);
      data.height = ea(frameOff, this.target.h, -offset.h, this.dur);
      data.rotate = ea(frameOff, this.target.rotate, -offset.r, this.dur);
    }
    return [data, position];
  }
  getOffsetData(data, position) {
    data.left = position.x + this.info.left - data.width / 2;
    data.top = position.y + this.info.top - data.height / 2;
    return data;
  }
  getCCW(frameOff) {
    return parseInt(frameOff / this.dur) % 2;
  }
  play(frameOff) {
    let s = this.sprite;
    let ccw = 0;
    let move = null;
    if(!this.loop && frameOff >= this.dur) {
      move = this.finally;
    } else {
      ccw = this.getCCW(frameOff);
      if(this.loop && frameOff >= this.dur) {
        frameOff = frameOff % this.dur;
      }
      move = this.getOffsetData(...this.offsetCalc(frameOff, ccw));
    }
    ({
      width: s.width,
      height: s.height,
      top: s.top,
      left: s.left,
      opacity: s.opacity,
      rotate: s.rotate
    } = move);
    if (move.textColor) {
      s.dom.firstElementChild.style.color = move.textColor;
    }
    if (s.type === 'Gif') {
      s.canvas.style.transform = `scale(${move.width / s.cWidth}, ${move.height / s.cHeight})`
    }
    if (s.cropType === 'free') {
      s.freeCropPath()
    }
    if (move.fillColor && move.fillColor !== this.preFillColor) {
      this.preFillColor = move.fillColor;
      GraphEffect.changeSvgFillColor(move.fillColor, s.svg);
    }
    this.reset = false;
  }
  finallyFrame() {
    let frameOff = 0,
      ccw = 0;
    if(!this.loop) {
      ccw = 0;
      frameOff = this.dur;
    } else {
      ccw = this.getCCW(frameOff);
      frameOff = (this.stayEnd - this.stayStart) % this.dur;
    }
    this.finally = this.getOffsetData(...this.offsetCalc(frameOff, ccw));
  }
  resetPath(){
    let s = this.sprite;
    ({
      width: s.width,
      height: s.height,
      top: s.top,
      left: s.left,
      opacity: s.opacity,
      rotate: s.rotate
    } = this.initData);
    if(this.finally.fillColor) {
      GraphEffect.changeSvgFillColor(s.fill, s.svg);
    }
    if (this.finally.textColor) {
      s.dom.firstElementChild.style.color = s.font.color;
    }
    this.reset = true;
  }
  static hex2rgb(hex) {
    let arr = [];
    hex = hex.toLowerCase();
    if(hex.length === 4) {
      let shex = '#';
      for(let i=1; i<4; i+=1){
        shex += hex.slice(i,i+1).concat(hex.slice(i,i+1));
      }
      hex = shex;
    }
    for(let i=1; i<7; i+=2) {
      arr.push(parseInt('0x' + hex.slice(i, i+2)));
    }
    return arr;
  }
  static rgb2hex(arr) {
    return '#' + ((1 << 24) + (arr[0] << 16) + (arr[1] << 8) + arr[2] << 0).toString(16).slice(1);
  }
  static changeSvgFillColor(hex, svg) {
    let urlFillRE = /url\(.*#.*\)/;
    svg.find('path').forEach(path => {
      let fill = path.css('fill');
      if(fill && fill !== 'none' && fill !== 'transparent' && !urlFillRE.test(fill)) {
        path.css('fill', hex);
      }
    });
  }
}
class PathGraphEffect extends GraphEffect {
  constructor(sprite, initData, pathAnim){
    super(sprite, initData, pathAnim);
  }
  getPath() {
    let info = this.line2path({
      w: this.initData.width,
      h: this.initData.height,
      x: this.initData.left,
      y: this.initData.top
    }, {
      w: this.target.w,
      h: this.target.h,
      x: this.target.x,
      y: this.target.y
    });
    Object.assign(this.info, info);
  }
  getPathStr() {
    return `M${this.info.path.join(',')}`;
  }
  line2path(bbox1, bbox2){
    var bbox = {};

    bbox1.cx = bbox1.x + bbox1.w / 2;
    bbox1.cy = bbox1.y + bbox1.h / 2;
    bbox2.cx = bbox2.x + bbox2.w / 2;
    bbox2.cy = bbox2.y + bbox2.h / 2;

    bbox.width = Math.abs(bbox1.cx - bbox2.cx);
    bbox.height = Math.abs(bbox1.cy - bbox2.cy);

    // 对应的四个象限和原点
    switch (true) {
      case bbox1.cx < bbox2.cx && bbox1.cy <= bbox2.cy:
        bbox.path = [0, 0, bbox.width, bbox.height];
        bbox.left = bbox1.cx;
        bbox.top = bbox1.cy;
        break;
      case bbox1.cx <= bbox2.cx && bbox1.cy > bbox2.cy:
        bbox.path = [0, bbox.height, bbox.width, 0];
        bbox.left = bbox1.cx;
        bbox.top = bbox2.cy;
        break;
      case bbox1.cx > bbox2.cx && bbox1.cy >= bbox2.cy:
        bbox.path = [bbox.width, bbox.height, 0, 0];
        bbox.left = bbox2.cx;
        bbox.top = bbox2.cy;
        break;
      case bbox1.cx >= bbox2.cx && bbox1.cy < bbox2.cy:
        bbox.path = [bbox.width, 0, 0, bbox.height];
        bbox.left = bbox2.cx;
        bbox.top = bbox1.cy;
        break;
      default:
        bbox.path = [0, 0, 0, 0];
        bbox.left = bbox1.cx;
        bbox.top = bbox1.cy;
        break;
    }

    return bbox;
  }
  initInfo(){
    this.getPath();
    this.createPathDom();
    this.getOffset();
    this.finallyFrame();
  }
}
class BesselGraphEffect extends GraphEffect {
  constructor(sprite, initData, pathAnim){
    super(sprite, initData, pathAnim);
  }
  getPathStr() {
    let _path = [].concat(this.info.path);
    _path.splice(2, 0, 'C');
    return `M${_path.join(' ')}`;
  }
  initInfo(){
    this.createPathDom();
    this.getOffset();
    this.info.top = this.initData.top + this.initData.height / 2 - this.info.path[1];
    this.info.left = this.initData.left + this.initData.width / 2 - this.info.path[0];
    this.finallyFrame();
  }
}
class EllipseGraphEffect extends GraphEffect {
  constructor(sprite, initData, pathAnim){
    super(sprite, initData, pathAnim);
  }
  getOffset(){
    this.offset = {
      w: 0,
      h: 0,
      r: 0,
      l: this.length,
      opacity: 0
    };
  }
  offsetCalc(frameOff, ccw){
    let [data, position] = super.offsetCalc(frameOff, ccw);
    position = StayEffect.rotateWithPoint(position, {x: this.info.width / 2, y: this.info.height /2 }, this.info.rotate);
    return [data, position];
  }
  getPath() {
    let cx = this.info.width / 2,
      rx = cx,
      cy = this.info.height / 2,
      ry = cy;
    let center = {
      x: this.initData.left + this.initData.width / 2,
      y: this.initData.top + this.initData.height / 2
    };
    let calcP = this.rotateLinePoint(center, cx, this.info.rotate);
    this.info.top = calcP.y - cy;
    this.info.left = calcP.x;
    this.info.path = this.ellipse2path(cx, cy, rx, ry, 1);
  }
  getPathStr() {
    return this.info.path;
  }
  initInfo(){
    this.getPath();
    this.createPathDom();
    this.getOffset();
    this.finallyFrame();
  }
  getCCW() {
    return this.info.ccw;
  }
  ellipse2path(cx, cy, rx, ry, a) {
    // 非数值单位计算，如当宽度像100%则移除
    // a后面分别意思为x轴半径,y轴半径,椭圆相当于x轴旋转度数，0表明弧线小于180读1大于180度，0表明弧线逆时针旋转1顺时间旋转,终点x,终点y
    if (isNaN(cx - cy + rx - ry)) return;
    let path =
      'M' + (cx-rx) + ' ' + cy +
      'a' + rx + ' ' + ry + ' 0 1 '+ a +' ' + 2*rx + ' 0' +
      'a' + rx + ' ' + ry + ' 0 1 '+ a +' ' + (-2*rx) + ' 0' +
      'z';

    return path;
  }
  rotateLinePoint(a, len, deg) {
    // 点a是点b由向x轴正方向延伸距离len的点c,然后绕点c旋转deg角度后的，此处求点b
    let b = {};

    deg = -Math.PI/180 * deg || 0;
    b.x = a.x - len * (1 - Math.cos(deg));
    b.y = a.y - len * Math.sin(deg);

    return b;
  }
}
class FreePathGraphEffect extends GraphEffect {
  constructor(sprite, initData, pathAnim){
    if(!pathAnim.info.points) {
      pathAnim.info.points = FreePathGraphEffect.pathToPoint(pathAnim.path)
    }
    super(sprite, initData, pathAnim);
  }
  getPathStr() {
    let path = '';
    let point = this.info.points;
    if(this.info.freePathType === 'line') {
      point.forEach((e, i) => {
        if (i === 0) {
          path = `M ${e[2]} ${e[3]}`;
        }else {
          path += ` ${e[2]} ${e[3]}`;
        }
      });
      if(this.info.close && point.length > 2) {
        path += ` ${point[0][2]} ${point[0][3]} Z`;
      }
    }else {
      point.forEach((e, i) => {
        if (i === 0) {
          path = `M ${e[2]} ${e[3]}`;
        }else {
          path += ` C ${point[i-1][4]} ${point[i-1][5]} ${e[0]} ${e[1]} ${e[2]} ${e[3]}`;
        }
      });
      if(this.info.close) {
        path += ` C ${point[point.length-1][4]} ${point[point.length-1][5]} ${point[0][0]} ${point[0][1]} ${point[0][2]} ${point[0][3]} Z`;
      }
    }
    return path;
  }
  initInfo(){
    this.createPathDom();
    this.getOffset();
    if (this.info.points.length > 0) {
      this.info.top = this.initData.top + this.initData.height / 2 - this.info.points[0][3];
      this.info.left = this.initData.left + this.initData.width / 2 - this.info.points[0][2];
    } else {
      this.info.top = this.initData.top + this.initData.height / 2;
      this.info.left = this.initData.left + this.initData.width / 2;
    }
    this.finallyFrame();
  }
  static pathToPoint(path) {
    // 兼容老版本的自由路径动画数据
    let points = [],
    point = [];
    let len = path.length / 2
    for (let i = 0; i < len; i++) {
      point = point.concat(path.slice(i * 2, i * 2 + 2))
      point = point.concat(point.concat(point))
      points[i] = point.splice(0, 6)
    }
    return points;
  }
}

class Camera {
  constructor(option){
    this.frameRate = option.frameRate;
    this.cameras = null;
    this.maxWidth = 1920;
    this.maxHeight = 1080;

    this.playData = null;
    this.scale = 1;
    this.top = 0;
    this.left = 0;
  }
  fromJson(json){
    // 不会改变值，不需要深度拷贝了
    if(json && json.length) {
      this.cameras = [].concat(json);
    } else {
      this.cameras = [{
        matrix: {
          w: this.maxWidth,
          h: this.maxHeight,
          x: 0,
          y: 0,
          r: 0
        },
        animations: {
          duration: 0,
          delay: 0
        },
        scale: 1
      }];
    }
    this.initData();
  }
  initData(){
    this.playData = [];
    for(let i in this.cameras) {
      this.cameras[i].scale = this.maxWidth / this.cameras[i].matrix.w;
      let t1 = Effect.ms2fps(this.cameras[i].animations.delay * 1000, this.frameRate);
      let t2 = t1 + Effect.ms2fps(this.cameras[i].animations.duration * 1000, this.frameRate);
      this.playData.push(t1, t2);
    }
  }
  play(frame){
    let num = -1,
      index = 0;
    for (let i = 0; i < this.playData.length; i++) {
      if (frame > this.playData[i]) {
        num++;
      } else {
        break;
      }
    }
    index = parseInt(num / 2);
    let now = this.cameras[index];
    if (index <= 0 || num % 2) {
      this.scale = now.scale;
      this.top = - now.matrix.y * now.scale;
      this.left = - now.matrix.x * now.scale;
    } else {
      if (frame > this.playData[num + 1]) frame = this.playData[num + 1];
      let offrame = frame - this.playData[num],
        prevs = this.cameras[index - 1],
        off = {
          time: this.playData[num + 1] - this.playData[num],
          scale: now.scale - prevs.scale,
          top: now.matrix.y * now.scale - prevs.matrix.y * prevs.scale,
          left: now.matrix.x * now.scale - prevs.matrix.x * prevs.scale
        };
      this.scale = EasingAnim[0](offrame, prevs.scale, off.scale, off.time);
      this.top = -EasingAnim[0](offrame, prevs.matrix.y * prevs.scale, off.top, off.time);
      this.left = -EasingAnim[0](offrame, prevs.matrix.x * prevs.scale, off.left, off.time);
    }
  }
  createDom(){
    let dom = document.createElement('div');
    dom.setAttribute('class', 'tool-scene-camera');
    dom.style.transform = `translate(${this.left}px, ${this.top}px) scale(${this.scale})`;
    return dom;
  }
}

export default AnimEditor;



// WEBPACK FOOTER //
// ./src/components/draftPreview/editor.js